/* Language pack: he */
export const translationsHe = {
	resumeRecording: "המשך",
	chatCallMissed: "שיחה שלא נענתה",
	chatCallDeclined: "נדחתה",
	chatAudioConference: "ועידת שמע",
	chatVideoConference: "ועידת וידאו",

	IDCardImages: "תמונות כרטיס זהות",
	IT: "הנדסת מחשבים",
	Status: "סטטוס",
	abbreviation: "קיצור",
	aboutUsItems: "פריטי אודותינו",
	absent: "נעדר",
	accept: "קבל",
	actSendingDate: "תאריך שליחת הפעולה",
	actionTimestamp: "חותמת זמן פעולה",
	actionType: "סוג פעולה",
	actions: "פעולות",
	activateStep7_8_9: "הקצאה למחלקת קווי העברת חשמל ( 7, 8, 9 )",
	activateStep8: "הקצאה למחלקת הגיאודזיה ( 8 )",
	activatedProjects: "פרויקטים מופעלים",
	active: "פעיל",
	activeCarts: "עגלות פעילות",
	activeClients: "לקוחות פעילים",
	activeCustomers: "לקוחות פעילים",
	activeProjectSteps: "שלבי פרויקט פעילים",
	activePromos: "מבצעים פעילים",
	activeSales: "מכירות פעילות",
	activeSalesEvents: "אירועי מכירות פעילים",
	activeServices: "שירותים פעילים",
	activeSteps: "צעדים פעילים",
	activeStreams: "זרמים פעילים",
	activeTasks: "משימות פעילות",
	activeTime: "זמן פעיל",
	activity: "פעילות",
	actualHours: "שעות אמיתיות",
	adInterval: "מרווח פרסומות",
	adIntervalOverride: "חוקי תכנון",
	adIntervalOverrideDesc: "חוקי תכנון",
	adIntervalOverrideValue: "חוקי תכנון",
	adPlaylist: "רשימת השמעה של מודעות",
	adPlaylists: "פלייליסטים לפרסומות",
	adTracks: "שירי פרסומת",
	add: "הוסף",
	addAttendance: "הוסף נוכחות",
	addFeature: "הוסף תכונה",
	addFeatureLine: "הוסף שורת תכונה",
	addFiles: "הוסף קבצים",
	addMoreFiles: "הוסף קבצים נוספים",
	addNew: "הוסף חדש",
	addPriceLine: "הוסף שורת מחיר",
	addRule: "הוסף חוק",
	addToList: "הוסף לרשימה",
	addVacationInterval: "הוסף מרווח חופשה",
	added: "הוסף",
	additionalDetails: "פרטים נוספים",
	address: "כתובת",
	addressData: "נתוני כתובת",
	advanceDeductions: "ניכויי מקדמה",
	advertisement: "פרסומת",
	age: "גיל",
	ageGroups: "קבוצות גיל",
	ago: "לפני",
	agreedProjects: "פרויקטים מוסכמים",
	agreementAquipment: "הסכם על ציוד",
	aiConversations: "שיחות",
	album: "אלבום",
	allArtists: "כל האמנים",
	allAudioTracks: "כל השירים",
	allContentItems: "כל פריטי התוכן",
	allFilesDeleted: "כל הקבצים נמחקו ללא שמירת נתונים",
	allFilesWillBeDeleted: "כל הקבצים יימחקו לצמיתות",
	allPlaylists: "כל הפלייליסטים",
	allRegisteredContacts: "כל הלקוחות הרשומים",
	allTickets: "כל הכרטיסים",
	amount: "סכום",
	analytics: "אנליטיקה",
	answer: "תשובה",
	apartment: "דירה",
	apply: "החל",
	appsMenu: "תפריט אפליקציות",
	approved: "אושר",
	approvedInterval: "מרווח מאושר",
	archive: "ארכיון",
	archived: "מאוחר מאוחרים",
	areYouSure: "אתה בטוח?",
	areYouSureToDelete: "האם אתה בטוח שברצונך למחוק את זה?",
	artist: "אמן",
	artistObject: "אובייקט זמרן",
	assignedTo: "מוקצה ל",
	assignedToUser: "מוקצה ל",
	assignmentToTheConstructionDepartment: "הקצאה למחלקת הבנייה",
	attach: "צרף",
	attachFile: "צרף קובץ",
	attachments: "קבצים מצורפים",
	attendance: "נוכחות",
	attendanceFlag: "סטטוס נוכחות",
	attendanceRequiringAttention: "עובדים הדורשים תשומת לב",
	attendanceNoAttentionItems: "אין עובדים הדורשים תשומת לב",
	attendanceMissingCheckIn: "חסרה כניסה",
	attendanceMissingCheckOut: "חסרה יציאה",
	attendanceEarlyLeave: "עזיבה מוקדמת",
	attendanceEarlyMissings: "עזיבות מוקדמות",
	attendanceEarlyMissingHours: "שעות עזיבה מוקדמת",
	attendanceLateHours: "שעות איחור",
	attendanceShowWorkedHours: "הצג שעות עבודה",
	attendanceUnapprovedAbsence: "היעדרות לא מאושרת",
	attendanceDeptAttendance: "נוכחות לפי מחלקה",
	attendanceDeviceHealth: "תקינות מכשירים וסנכרון חי",
	attendanceLastSync: "סנכרון אחרון",
	attendanceLiveFeed: "פיד נוכחות חי",
	attendanceNoRecentPunches: "אין חבטות אחרונות",
	attendanceManualEntryTag: "ידני",
	attendanceUnmappedPunch: "לא משויך",
	attendancePendingItems: "ממתין",
	flexCardTotal: "כרטיסי Flex",
	attendanceCards: "כרטיסי נוכחות",
	flexCardTotalSubtitle: "מזהי Flex שהוקצו או הוזנחו",
	flexCardsAttached: "מקושר",
	flexCardsAttachedSubtitle: "מזהים ייחודיים המקושרים למשתמשים",
	flexCardsIgnored: "הוזנח",
	flexCardsIgnoredSubtitle: "הוזנח בהגדרות משאבי אנוש",
	flexCardsDuplicateAttached: "קושר בכפילות",
	flexCardIds: "מזהי כרטיסים",
	noDuplicateFlexCards: "אין כפילויות",
	attendanceTrendPctOfEmployeesPresent: "% מהעובדים הנוכחים",
	yesterday: "אתמול",
	attendanceFilterThisWeek: "השבוע",
	attendanceFilterThisMonth: "החודש",
	attendanceFilterCustom: "מותאם אישית",
	attendanceSelectRange: "בחר טווח",
	attendanceCustomRangeCapped: "טווח מותאם אישית מוגבל ל-90 יום",
	attendanceLiveBadge: "LIVE",
	attendanceTitleToday: "נוכחות היום",
	attendanceTitleYesterday: "נוכחות אתמול",
	attendanceTitleThisWeek: "נוכחות השבוע",
	attendanceTitleThisMonth: "נוכחות החודש",
	attendanceTitleCustom: "נוכחות לתקופה שנבחרה",
	attendanceTitleTodayKpis: "מדדי נוכחות היום",
	attendanceTitleYesterdayKpis: "מדדי נוכחות אתמול",
	attendanceTitleThisWeekKpis: "מדדי נוכחות השבוע",
	attendanceTitleThisMonthKpis: "מדדי נוכחות החודש",
	attendanceTitleCustomKpis: "מדדי התקופה שנבחרה",
	attendanceTrendDays: "מגמת נוכחות — {n} הימים האחרונים",
	attendanceNotAttendedYet: "טרם הגיעו",
	attendanceUpcomingAbsences: "היעדרויות קרובות",
	attendanceUpcomingAbsencesEmpty: "אין היעדרויות קרובות",
	attendanceUpcomingAbsencesTomorrow: "מחר",
	attendanceUpcomingAbsencesInDays: "בעוד {days} ימים",
	attendanceExceptions: "חריגות נוכחות",
	attendanceExceptionsMissingCheckIn: "כניסות חסרות",
	attendanceExceptionsMissingCheckOut: "יציאות חסרות",
	attendanceExceptionsEarlyLeaves: "עזיבות מוקדמות",
	attendanceExceptionsUnapprovedAbsences: "היעדרויות לא מאושרות",
	attendanceExceptionsDuplicatePunches: "הקשות כפולות",
	attendanceMonthlyKpis: "מדדי נוכחות חודשיים",
	attendanceKpiRate: "שיעור נוכחות",
	attendanceKpiAvgArrival: "שעת הגעה ממוצעת",
	attendanceKpiLateArrivals: "איחורים",
	attendanceKpiAbsentDays: "ימי היעדרות",
	attendanceKpiOvertimeHours: "שעות נוספות",
	attendanceLeaveBalanceOverview: "סקירת יתרת חופשה",
	attendanceLeaveBalanceVacationRemaining: "יתרת חופשה",
	attendanceLeaveBalanceSickUsed: "ימי מחלה שנוצלו",
	attendanceLeaveBalanceBusinessTrips: "נסיעות עסקים",
	attendanceLeaveBalancePendingRequests: "בקשות ממתינות",
	attendanceLeaveBalanceCoverage: "{covered} מתוך {total} עובדים",
	attendanceTopInsights: "תובנות נוכחות מובילות",
	attendanceInsightNoData: "אין עדיין נתונים",
	attendanceInsightHighestLateness: "ל-{dept} יש את שיעור האיחורים הגבוה ביותר השבוע ({delta})",
	attendanceInsightFullAttendanceToday: "ל-{dept} יש נוכחות של 100%",
	attendanceInsightTrendImproved: "הנוכחות השתפרה ב-{pct}% לעומת התקופה הקודמת",
	attendanceInsightTrendDeclined: "הנוכחות ירדה ב-{pct}% לעומת התקופה הקודמת",
	attendanceInsightApproachingOvertime: "{count} עובדים מתקרבים למגבלת השעות הנוספות",
	attendancePreviousWeek: "שבוע שעבר",
	attendanceCurrentWeek: "השבוע",
	attendanceAddInterval: "הוסף מרווח",
	attendanceBreakLabel: "הפסקה",
	attendanceCorrectionMode: "מצב תיקון",
	attendanceCustomIntervals: "מרווחים מותאמים",
	attendanceDashboard: "לוח נוכחות",
	attendanceReports: "דוחות",
	attendanceCalendarTab: "לוח שנה",
	reports: "דוחות",
	shiftCoverage: "כיסוי משמרות",
	previousPeriod: "תקופה קודמת",
	nextPeriod: "תקופה הבאה",
	failedToSave: "לא ניתן לשמור את הערת שעות הנוספות",
	expandForDailyDetail: "הרחב שורה לפרטים יומיים",
	noDataForPeriod: "אין נתונים לתקופה זו",
	attendanceHistory: "היסטוריית נוכחות",
	attendanceDayOffTab: "יום חופש",
	attendanceDayType: "סוג היום",
	attendanceDetectedIntervals: "מרווחים שזוהו",
	attendanceEditDay: "עריכת היום",
	attendanceHrsTotal: "ש׳ סה״כ",
	attendanceViewWeek: "שבוע",
	attendanceViewMonth: "חודש",
	attendanceViewDay: "יום",
	day: "יום",
	attendanceOpenFrom: "פתוח מ-{time}",
	attendanceFromStillActive: "מ-{time} → עדיין פעיל",
	attendanceTotalWorked: "סה״כ עבודה",
	attendanceMissingUncovered: "חסר / לא מכוסה",
	attendanceNoData: "אין נתונים",
	attendanceNoDataForDay: "אין נתוני נוכחות ליום זה.",
	attendanceIntervalApprovedOk: "מאושר / בסדר",
	attendanceIntervalEachRowInvalid: "נא להזין זמן התחלה וסיום תקפים לכל מרווח",
	attendanceIntervalTimesInvalid: "נא להזין זמן התחלה וסיום תקפים",
	attendanceIntervalsMode: "מרווחים",
	attendanceIntervalsReviewHint:
		"עיינו במרווחי עבודה בפועל, בחופשה ובחוסרים. הוסיפו מטה מרווחי תיקון ידניים לסימון: מאושר, עבודה, מרחוק, מחלה, חופשה, ללא תשלום או אחר.",
	attendanceLogSubtitle: "הזנת נוכחות ידנית — עבודה, מחלה, חופשה",
	attendanceLogTitle: "יומן נוכחות",
	attendanceManualResolutionIntervals: "מרווחי תיקון ידניים",
	attendanceMissingLabel: "חסר",
	attendanceNoManualIntervalsYet: "טרם נוספו מרווחים ידניים",
	attendanceNoUncovered: "לא זוהו מרווחים לא מכוסים",
	attendanceOptionalNotePlaceholder: "הערה אופציונלית…",
	attendancePtoLeaveSection: "חופשה בתשלום / חופשה",
	attendanceReport: "דוח נוכחות",
	attendanceResolveInterval: "פתור מרווח זה",
	attendanceResyncTooltip: "סנכרן מחדש נוכחות לעובד זה",
	attendanceResyncSuccess: "סנכרון מחדש של הנוכחות החל",
	attendanceResyncFailed: "סנכרון מחדש של הנוכחות נכשל",
	attendanceSavedSuccess: "הנוכחות נשמרה בהצלחה",
	attendanceStatusUpcoming: "עתידי",
	attendanceSelectEmployeePrompt: "בחרו עובד לצפייה בנוכחות",
	attendanceTrend: "מגמת נוכחות",
	attendanceTrendPctPresent: "% נוכחים",
	attendanceUncoveredMissing: "לא מכוסה / חסר",
	attendanceUnsavedChanges: "שינויים שלא נשמרו",
	attendanceWholeDayStatus: "סטטוס יום שלם",
	shiftWorker: "עובד במשמרות",
	attendanceIgnoreMode: "התעלמות",
	attendanceIgnoreScopeWeekdays: "ימי שבוע",
	attendanceIgnoreScopeDateRange: "טווח תאריכים",
	attendanceIgnoreScopeWeekdaysHint: "חל רק על ימי השבוע שנבחרו בתקופה זו.",
	attendanceIgnoreScopeDateRangeHint: "חל על כל יום בתקופה זו.",
	attendanceIgnoreAppliesTo: "חל על",
	attendanceIgnoreLateArrival: "איחור בהגעה",
	attendanceIgnoreEarlyLeave: "יציאה מוקדמת",
	attendanceIgnoreWindowStart: "תחילת חלון ההתעלמות",
	attendanceIgnoreWindowEnd: "סוף חלון ההתעלמות",
	attendanceIgnoreRulesList: "כללי התעלמות",
	attendanceIgnoreRulesEmpty: "עדיין אין כללי התעלמות",
	attendanceIgnoreDaysOfWeekRequired: "בחר לפחות יום אחד",
	attendanceIgnoredLabel: "הותעלם",
	attendanceNoCardLabel: "אין כרטיס",
	attendanceWork: "עבודה",
	attendanceWorked: "עבוד",
	attendanceWorkedIntervals: "מרווחי עבודה",
	attendanceMissingIntervals: "מרווחים חסרים",
	attendanceStillInOffice: "עדיין במשרד",
	attendanceAddEvent: "הוסף אירוע",
	attendanceAddAttendanceEvent: "הוסף אירוע נוכחות",
	attendanceDeleteEventTitle: "למחוק אירוע נוכחות?",
	attendanceDeleteEventText: "פעולה זו מסירה רק את אירוע הכניסה/יציאה שנוסף ידנית.",
	attendanceNoMissingIntervals: "אין מרווחים חסרים ליום זה",
	attendanceOfficeSince: "מ-{time}",
	attendanceLastOutAt: "יציאה אחרונה {time}",
	attendanceEventSingular: "אירוע",
	attendanceEventPlural: "אירועים",
	attendancePunchIn: "כניסה",
	attendancePunchOut: "יציאה",
	solveThis: "לפתור",
	editSolvedStatus: "ערוך סטטוס שנפתר",
	officeStatus: "סטטוס משרד",
	outOfOffice: "מחוץ למשרד",
	noPunches: "אין רישומים",
	lastActionWasCheckIn: "הפעולה האחרונה הייתה כניסה",
	lastActionWasCheckOut: "הפעולה האחרונה הייתה יציאה",
	noCheckInYet: "עדיין אין כניסה",
	manual: "ידני",
	resolved: "נפתר",
	attendanceManualStatusApplyTicketTimeTo: "להחיל את זמן הכרטיס על",
	attendanceManualStatusColumnAttendanceType: "סוג נוכחות",
	attendanceManualStatusColumnTimeAction: "פעולת זמן",
	attendanceManualStatusMapsToType: "ממופה לסוג נוכחות",
	attendanceManualStatusTicketTimeAction: "פעולת זמן באוטומציה של כרטיס",
	attendanceTicketTimePhraseAdd: "להוסיף זמן {type}",
	attendanceTicketTimePhraseSubtract: "לנכות זמן {type}",
	attendanceTimeOpAdd: "להוסיף זמן כרטיס",
	attendanceTimeOpNone: "ללא שינוי במאזן הזמן",
	attendanceTimeOpSubtract: "לנכות זמן כרטיס",
	attendanceTypeOptionAbsent: "נעדר",
	attendanceTypeOptionBusinessTrip: "נסיעת עסקים",
	attendanceTypeOptionHolidayNonWorking: "חג / יום לא עבודה",
	attendanceTypeOptionJustifiedAbsence: "היעדרות מוצדקת (באישור)",
	attendanceTypeOptionMaternity: "חופשת לידה",
	attendanceTypeOptionPaidVacation: "חופשה בתשלום",
	attendanceTypeOptionRemote: "עבודה מרחוק",
	attendanceTypeOptionSickLeave: "מחלה",
	attendanceTypeOptionUnjustifiedAbsence: "היעדרות בלתי מוצדקת (ללא אישור)",
	attendanceTypeOptionUnpaidLeave: "חופשה ללא תשלום",
	attendanceTypeOptionWork: "עבודה",
	audio: "אודיו",
	autoDeletion: "מחיקה אוטומטית",
	averageDailyHours: "ממוצע שעות יומי",
	avgDaily: "ממוצע יומי",
	avgDailyHours: "ממוצע שעות יומיות",
	avgHoursPerWorkingDay: "ממוצע שעות ליום עבודה",
	avgOrderValue: "ערך הזמנה ממוצע",
	avgResolutionTime: "זמן פתרון ממוצע",
	avgResponseTime: "זמן תגובה ממוצע",
	avgTracksPerPlaylist: "ממוצע שירים/פלייליסט",
	back: "חזור",
	bank: "בנק",
	bankAccount: "חשבון בנק",
	bankCart: "כרטיס בנק",
	bankEmitet: "בנק",
	banner: "באנר",
	baseSalary: "שכר בסיס",
	baseSalaryHourlyLinked: "מעדכן שכר שעתי מבסיס ÷ שעות רגילות (כששעות > 0).",
	basicInformation: "מידע בסיסי",
	beginningOfAcquaintance: "תחילת היכרות",
	beginningOfContract: "תחילת החוזה",
	beginningOfTraining: "תחילת ההכשרה",
	benefits: "הטבות",
	bestSeller: "המוכר ביותר",
	bestSellers: "הנמכרים ביותר",
	bestSellingItemsByRevenue: "הפריטים הנמכרים ביותר לפי הכנסות",
	bitrate: "קצב סיביות",
	biweekly: "דו-שבועי",
	blogItems: "פריטי בלוג",
	blogs: "בלוגים",
	bonuses: "בונוסים",
	bpm: "BPM",
	branch: "סניף רשת חשמל",
	branches: "רשימת סניפים",
	branchesCitiesVillages: "סניפים, ערים, כפרים",
	brand: "מותג",
	brands: "מותגים",
	building: "בניין",
	businessTrip: "נסיעת עסקים",
	buttonText: "טקסט לחצן",
	bypassSteps: "דילוג על שלבים",
	calAddCalendarTooltip: "צור יומן ושתף עם חברי צוות",
	calAddEvent: "הוסף אירוע",
	calAddReminder: "הוסף תזכורת",
	calAlarm15m: "15 דקות לפני",
	calAlarm1d: "יום לפני",
	calAlarm1h: "שעה לפני",
	calAlarm1w: "שבוע לפני",
	calAlarm2d: "יומיים לפני",
	calAlarm2h: "שעתיים לפני",
	calAlarm30m: "30 דקות לפני",
	calAlarm5m: "5 דקות לפני",
	calAlarmAtEvent: "בזמן האירוע",
	calAllDay: "כל היום",
	calApiNotConfigured: "ממשק היומן לא מוגדר.",
	calCalendarColorLabel: "צבע היומן",
	calCalendarCreateFailed: "לא ניתן ליצור יומן",
	calCalendarCreated: "היומן נוצר",
	calCalendarDeleted: "לוח השנה נמחק",
	calCalendarNameLabel: "שם היומן",
	calCalendarNamePh: "למשל תכנון צוות",
	calCalendarNameRequired: "הזן שם יומן",
	calCalendarSelect: "יומן",
	calCalendarUpdateFailed: "לא ניתן לעדכן את היומן",
	calCalendarUpdated: "היומן עודכן",
	calCalendarsLabel: "יומנים:",
	calGoogleCalendarLabel: "Google Calendar:",
	calGoogleCalendarPrefix: "Google",
	calMeetingsLabel: "פגישות:",
	calCancel: "ביטול",
	calCheckAll: "בחר הכל",
	calColor: "צבע",
	calCreateCalendar: "צור יומן",
	calDay: "יום",
	calDayOverviewTitle: "יום",
	calDefaultCalendarName: "יומן",
	calDelete: "מחק",
	calDeleteCalendarHasEvents: "לוח שנה זה מכיל {count} אירועים. מה ברצונך לעשות איתם?",
	calDeleteCalendarNoEvents: "לא ניתן לבטל פעולה זו.",
	calDeleteCalendarOnly: "מחק רק את לוח השנה",
	calDeleteCalendarTitle: "למחוק לוח שנה?",
	calDeleteCalendarWithEvents: "מחק עם אירועים",
	calDeleteEventText: "לא ניתן לבטל פעולה זו.",
	calDeleteEventTitle: "למחוק אירוע?",
	calDeleteFailed: "המחיקה נכשלה",
	calDescription: "תיאור",
	calDescriptionPh: "תיאור אופציונלי",
	calEditCalendarTitle: "ערוך יומן",
	calEditCalendarTooltip: "ערוך יומן",
	calEditEvent: "ערוך אירוע",
	calEditTooltip: "עריכה",
	calEnd: "סוף",
	calEndBeforeStart: "הסיום לא יכול להיות לפני ההתחלה",
	calEndTime: "שעת סיום",
	calEvent: "אירוע",
	calEventCreated: "האירוע נוצר",
	calEventDeleted: "האירוע נמחק",
	calEventTitle: "כותרת",
	calEventTitlePh: "כותרת האירוע",
	calEventUpdated: "האירוע עודכן",
	calEventsPlural: "אירועים",
	calExportIcs: "ייצוא .ics",
	calFailedLoadEvents: "טעינת אירועים נכשלה",
	calHrBirthdayEvent: "יום הולדת",
	calHrBirthdays: "ימי הולדת",
	calHrContractEnd: "סיום חוזה",
	calHrContractEndEvent: "סיום חוזה",
	calHrContractStart: "תחילת חוזה",
	calHrContractStartEvent: "תחילת חוזה",
	calHrIdEvent: "תפוגת תעודה",
	calHrIdExpiry: "תפוגת תעודה",
	calHrPassportEvent: "תפוגת דרכון",
	calHrPassportExpiry: "תפוגת דרכון",
	calHrPositionReview: "סקירת תפקיד",
	calHrPositionReviewEvent: "סקירת תפקיד",
	calHrSalaryReview: "סקירת שכר",
	calHrSalaryReviewEvent: "סקירת שכר",
	calImportButton: "ייבוא",
	calImportEventsTitle: "ייבוא אירועים",
	calImportFoundInFile: "נמצאו בקובץ. בחרו יומן לייבוא:",
	calImportIcs: "ייבוא .ics",
	calImportedEventTitle: "אירוע מיובא",
	calItLabel: "IT:",
	calItWarrantyEnd: "סיום אחריות",
	calItWarrantyEndEvent: "סיום אחריות",
	calMonth: "חודש",
	calNewCalendarTitle: "יומן חדש",
	calNewEvent: "אירוע חדש",
	calNoCalendar: "ללא יומן",
	calNoCalendarUncategorised: "ללא יומן (ללא קטגוריה)",
	calNoEventsInIcs: "אין אירועים בקובץ .ics",
	calNoEventsThisDay: "אין אירועים ביום זה.",
	calNoRemindersThisDay: "אין תזכורות ביום זה.",
	calDayWeatherMap: "מפת מזג אוויר",
	calDayHourlyForecast: "תחזית שעתית",
	calDayWeatherUnavailable: "תחזית לא זמינה לתאריך זה",
	calDayEventsSection: "אירועים",
	calDayRemindersSection: "תזכורות",
	calOpenProfile: "פתח פרופיל",
	calPeopleLabel: "אנשים:",
	calReminders: "תזכורות",
	calRemindersLabel: "תזכורות:",
	calAttendanceLabel: "נוכחות:",
	calSecurityLabel: "אבטחה:",
	calSecurityAlerts: "התראות",
	calSecuritySessions: "פגישות",
	calSecurityTokenExpiry: "תפוגת אסימון",
	calRemindersToggle: "תזכורות פעילות",
	calSave: "שמור",
	calSaveFailed: "השמירה נכשלה",
	calShareWithUsers: "שיתוף עם משתמשים",
	calShareWithUsersPh: "חפש ובחר אנשים",
	calStart: "התחלה",
	calStartEndRequired: "נדרשים זמן התחלה וסיום",
	calStartTime: "שעת התחלה",
	calSwalDelete: "מחק",
	calTaskHigh: "גבוה",
	calTaskLow: "נמוך",
	calTaskMedium: "בינוני",
	calTaskUrgent: "דחוף",
	calTasksLabel: "משימות:",
	calTicketsLabel: "קריאות:",
	calToday: "היום",
	calUserFallback: "משתמש",
	calWeek: "שבוע",
	calculatePayroll: "חשב תלוש שכר",
	calculated: "מחושב",
	calculations: "חישובים",
	calendarEventType: "אירוע ביומן",
	calling: "שיחה",
	cancel: "ביטול",
	clearText: "נקה טקסט",
	cancelAction: "ביטול פעולה",
	cancelBack: "בטל חזרה",
	cancelled: "ביטול",
	cannotBeUndone: "לא ניתן לבטל פעולה זו.",
	cannotPayOnline: "לא ניתן לשלם אונליין",
	cart: "עובדים",
	categories: "קטגוריות",
	category: "קטגוריה",
	categoryPerformance: "ביצועי קטגוריה",
	certificate: "תעודה",
	certificateImages: "תמונות תעודות",
	certificates: "תעודות",
	changedDate: "תאריך שינוי",
	channel: "ערוץ",
	channelWritePermissionDescription: "רק מנהלי הצ'אט יכולים לכתוב הודעות",
	channels: "ערוצים",
	charts: "תרשימים",
	chatActions: "פעולות צאט",
	chatActiveLabel: "פעיל...",
	chatAddOption: "הוסף אפשרות",
	chatAddUsers: "הוסף משתמשים",
	chatAddedToGroupNotification: "נוספת לצ׳אט קבוצתי",
	chatAddedYouToGroup: "הוסיף אותך אל",
	chatAudioCall: "שיחת אודיו",
	chatBulkDeleteFailed: "מחיקה מרובה נכשלה.",
	chatBulkForwardFailed: "העברה מרובה נכשלה.",
	chatCallMessage: "הודעת שיחה",
	chatChoosingEmoji: "בוחרים אימוגי...",
	chatClickMapToChoosePoint: "לחץ על המפה כדי לבחור נקודה מותאמת.",
	chatCoordinatesUnavailable: "קואורדינטות לא זמינות",
	chatCopyCoordinates: "העתק קואורדינטות",
	chatCopyCoordinatesFailed: "העתקת הקואורדינטות נכשלה.",
	chatCreatePoll: "צור סקר",
	chatCurrent: "נוכחי",
	chatCurrentLocation: "מיקום נוכחי",
	chatDashboard: "לוח בקרת צ'אט",
	chatDeleteFailed: "המחיקה נכשלה",
	chatDeleteForMeOnly: "מחק רק בשבילי",
	chatDeleteForParticipants: "מחק גם עבור משתתפים",
	chatDeleteLocation: "מחק מיקום",
	chatDeleteSelectedMessagesDescription:
		"פעולה זו מסירה הודעות שנבחרו מתצוגת הצאט שלך. הודעות שלא ניתן למחוק בהרשאות הנוכחיות יסומנו ככשלון.",
	chatDeleteSelectedMessagesTitle: "מחק הודעות שנבחרו",
	chatDeletionPartialWarning:
		"תוצאות המחיקה עשויות להיות חלקיות אם חלק מההודעות כבר נמחקו או שבדיקות הרשאה נכשלו.",
	chatDepartmentSaveFailed: "עדכון המחלקה נכשל",
	chatDepartmentSaveFailedTryAgain: "נסה לעדכן את המחלקה שוב.",
	chatDeselectAllMessages: "בטל בחירה",
	chatDestinationChatsLabel: "צאטים יעד",
	chatDestinationChatsPlaceholder: "בחר צאט אחד או יותר",
	chatDirect: "צ'אט ישיר",
	chatDirectChat: "צאט ישיר",
	chatEditFailed: "לא ניתן לערוך את ההודעה",
	chatEditFailedTryAgain: "נסה לערוך שוב.",
	chatEditMessagePlaceholder: "ערוך הודעה...",
	writeMessage: "הקלד הודעה...",
	chatEditingMessage: "עורך הודעה",
	chatExitSelectionMode: "צא ממצב בחירה",
	chatExpired: "פג תוקף",
	chatForwardFailed: "ההעברה נכשלה",
	chatForwardSelectedMessagesTitle: "העבר הודעות שנבחרו",
	chatForwardableLabel: "ניתנות להעברה",
	chatGeolocationUnavailable: "מיקום גאוגרפי אינו זמין בדפדפן זה.",
	chatGroupChat: "צ׳אט קבוצתי",
	chatGroupInfo: "פרטי קבוצה",
	chatGroupMembers: "חברי קבוצה",
	chatGroupSettings: "הגדרות קבוצה",
	chatGroupSettingsDescription: "הגדר תמונת קבוצה ומחלקת משאבי אנוש מקושרת",
	chatID: "מזהה צ'אט",
	chatImageUploadFailed: "העלאת התמונה נכשלה",
	chatImageUploadFailedTryAgain: "נסה להעלות תמונה אחרת.",
	chatIncludeLabel: "כלול",
	chatIsChoosingEmoji: "בוחר אימוגי...",
	chatIsTyping: "מקליד...",
	chatLastUpdated: "עודכן לאחרונה",
	chatLatitude: "קו רוחב",
	chatLive: "חי",
	chatLiveFor: "חי למשך",
	chatLiveLocation: "מיקום חי",
	chatLiveLocationOptInWarning: "מיקום חי דורש אישור מפורש וניתן לעצור בכל עת.",
	chatLiveLocationSharingActive: "שיתוף מיקום חי פעיל",
	chatLoadingLocation: "טוען מיקום...",
	chatLoadingPoll: "טוען סקר...",
	chatLongitude: "קו אורך",
	chatMessagesCannotBeForwarded: "הודעה/ות לא ניתנות להעברה וידולגו.",
	chatMessagesDeleted: "ההודעות נמחקו",
	chatMessagesForwarded: "ההודעות הועברו",
	chatMoreActions: "פעולות נוספות",
	chatNoAvailableUsersToAdd: "כל המשתמשים הזמינים כבר נמצאים בקבוצה הזו.",
	chatNoBackground: "ללא רקע",
	chatNoChatsFound: "לא נמצאו צאטים",
	chatNoMessagesForwarded: "לא ניתן היה להעביר הודעות.",
	chatNoSelectedMessagesDeleted: "לא ניתן היה למחוק אף הודעה שנבחרה.",
	chatOpenDepartmentPage: "פתח דף מחלקה",
	chatOpenMap: "פתח מפה",
	chatOptionalAddressLabel: "תווית כתובת אופציונלית",
	chatOwnMessagesLabel: "שלי",
	chatPartialDelete: "מחיקה חלקית",
	chatPartialForward: "העברה חלקית",
	chatPattern: "תבנית",
	chatPickOnMap: "בחר על המפה",
	chatPickPointOnMap: "בחר נקודה על המפה.",
	chatPinnedLocation: "מיקום מוצמד",
	chatPollAddAnotherOption: "הוסף אפשרות נוספת",
	chatPollAddOptionFailed: "הוספת אפשרות נכשלה.",
	chatPollAllowAddingOptions: "אפשר הוספת אפשרויות",
	chatPollAllowMultipleAnswers: "אפשר מספר תשובות",
	chatPollAllowRevote: "אפשר הצבעה מחדש",
	chatPollAnonymous: "סקר אנונימי",
	chatPollAnonymousCannotAddOptions: "חידון אנונימי לא יכול לאפשר הוספת אפשרויות.",
	chatPollAtLeastOptions: "נדרשות לפחות אפשרויות:",
	chatPollAutoClose: "סגירה אוטומטית",
	chatPollChangeVote: "שנה הצבעה",
	chatPollChooseCorrectAnswer: "בחר לפחות תשובה נכונה אחת לחידון.",
	chatPollCloseDate: "תאריך סגירה",
	chatPollCloseDateOrOpenPeriod: "השתמש בתאריך סגירה או פרק זמן פתוח, לא בשניהם.",
	chatPollCloseFailed: "סגירת הסקר נכשלה.",
	chatPollClosePoll: "סגור סקר",
	chatPollCorrectAnswer: "תשובה נכונה",
	chatPollCorrectAnswers: "תשובות נכונות",
	chatPollCreateFailed: "יצירת הסקר נכשלה.",
	chatPollDeletePoll: "מחק סקר",
	chatPollDescriptionMax: "התיאור לכל היותר",
	chatPollExplanationMax: "ההסבר לכל היותר",
	chatPollHideResultsUntilClosed: "הסתר תוצאות עד סגירה",
	chatPollIncorrectAnswer: "תשובה שגויה",
	chatPollLeaveEmptyKeepOpen: "השאר ריק כדי להשאיר את הסקר פתוח",
	chatPollLeaveEmptyNoTimer: "השאר ריק ללא טיימר",
	chatPollLoadVotersFailed: "טעינת המצביעים נכשלה.",
	chatPollMultipleChoice: "בחירה מרובה",
	chatPollNewOption: "אפשרות חדשה",
	chatPollNoVoteYet: "עדיין אין הצבעה",
	chatPollNoVotersForOption: "לא נמצאו מצביעים עבור אפשרות זו.",
	chatPollOpenPeriod: "תקופת פתיחה",
	chatPollOptionMax: "אפשרות באורך לכל היותר",
	chatPollOptionRequired: "אפשרות היא שדה חובה.",
	chatPollOptionsUnique: "האפשרויות חייבות להיות ייחודיות.",
	chatPollPublic: "ציבורי",
	chatPollQuestionMax: "אורך השאלה לכל היותר",
	chatPollQuestionRequired: "השאלה היא שדה חובה.",
	chatPollQuiz: "בוחן",
	chatPollQuizExplanation: "הסבר החידון",
	chatPollRegular: "רגיל",
	chatPollResultsHiddenUntilClosed: "התוצאות מוסתרות עד לסגירת הסקר.",
	chatPollSearchVoters: "חפש מצביעים",
	chatPollShuffleOptions: "ערבב אפשרויות",
	chatPollSingleChoice: "בחירה יחידה",
	chatPollSingleChoiceOneCorrect: "בחידון בחירה יחידה יכולה להיות תשובה נכונה אחת בלבד.",
	chatPollSubmitVoteFailed: "שליחת ההצבעה נכשלה.",
	chatPollViewVoters: "הצג מצביעים",
	chatPollVoteRecorded: "ההצבעה נרשמה",
	chatPollVotersLabel: "מצביעים",
	chatPollVotersTitle: "מצביעי הסקר",
	chatPollYouVoted: "הצבעת.",
	chatPollYouVotedCanChange: "הצבעת וניתן לשנות את התשובה.",
	chatPreviewChronological: "תצוגה מקדימה (כרונולוגי)",
	chatProvider: "ספק",
	chatReadCurrentLocationFailed: "נכשל בקריאת המיקום הנוכחי שלך.",
	chatRefreshCurrentLocation: "רענן מיקום נוכחי",
	chatRuleAllow: "כן",
	chatRuleDeny: "לא",
	chatRuleTimed: "כן, אבל לזמן מוגבל",
	chatRuleTimerDescription: "לדוגמה: קבע 1 כדי לאפשר את הפעולה רק בדקה הראשונה אחרי השליחה.",
	chatRuleTimerMinutes: "טיימר בדקות",
	chatSearchMessage: "חפש הודעה",
	chatSelectAllMessages: "בחר הכל",
	chatSelectDepartment: "בחר מחלקת משאבי אנוש",
	chatSelectOrLoadLocationFirst: "בחר או טען מיקום תחילה.",
	chatSelectRepeatingBackground: "בחר רקע חוזר",
	chatSelectUsersToAdd: "בחר משתמשים להוספה",
	chatSelectedLabel: "נבחר",
	chatSelectionMode: "מצב בחירה",
	chatSendCurrentLocation: "שלח מיקום נוכחי",
	chatSendLocationFailed: "שליחת מיקום נכשלה.",
	chatSendPinnedLocation: "שלח מיקום מוצמד",
	chatSendVenue: "שלח מקום",
	chatSentAt: "נשלח",
	chatSettings: "הגדרות צאט",
	chatSettingsEditRule: "עריכת הודעות",
	chatSettingsEditRuleDescription:
		"בחר האם אפשר לערוך הודעות שנשלחו תמיד, אף פעם, או רק לזמן מוגבל.",
	chatSettingsForwardRule: "העברת הודעות",
	chatSettingsForwardRuleDescription:
		"אפשר העברה תמיד, אף פעם, או רק לזמן מוגבל אחרי שליחת ההודעה המקורית.",
	chatSettingsGlobalPageSubtitle:
		"הגדירו כאן פעם אחת את כללי הצ'אטים האישיים. רק מנהלי קבוצה יכולים לשנות את כללי הקבוצה.",
	chatSettingsGlobalPageTitle: "הגדרות צ'אט גלובליות",
	chatSettingsGlobalRulesDescription: "הכללים האלה חלים על כל הצ'אטים האישיים.",
	chatSettingsGlobalSavedSuccess: "הגדרות הצ'אט הגלובליות עודכנו בהצלחה",
	chatSettingsCompactMode: "מצב קומפקטי",
	chatSettingsCompactModeDescription:
		"הקטן את המרווחים ואת גודל התמונות כדי להציג יותר צ'אטים בסרגל הצד.",
	chatSettingsSidebarDescription: "קבע כיצד הצ'אטים יוצגו בסרגל הצד השמאלי.",
	chatSettingsSidebarTitle: "סרגל הצד של הצ'אט",
	chatSettingsShowLastMessage: "הצג הודעה אחרונה",
	chatSettingsShowLastMessageDescription: "הצג את ההודעה האחרונה ואת התאריך או השעה שלה בסרגל הצד של הצ'אט.",
	chatSettingsReplyRule: "השבה להודעות",
	chatSettingsReplyRuleDescription:
		"קבע אם אפשר להשיב תמיד, אף פעם, או רק בתוך חלון זמן אחרי שליחת ההודעה.",
	chatSettingsResetToGlobal: "שחזור כללי ברירת המחדל של הקבוצה",
	chatSettingsRulesAdminOnly: "רק מנהלי הצ'אט יכולים לשנות את הכללים האלה.",
	chatSettingsRulesDescription:
		"הגדר האם חברים יכולים להעביר, להשיב או לערוך הודעות, ואפשר גם להגביל בזמן.",
	chatSettingsRulesTitle: "כללי צ'אט",
	chatSettingsSaveFailed: "לא ניתן לשמור את הגדרות הצ'אט",
	chatSettingsSaveFailedTryAgain: "נסה שוב.",
	chatSettingsUsingCustomRules: "הקבוצה משתמשת בכללים שקבעו המנהלים.",
	chatSettingsUsingGlobalRules: "הקבוצה משתמשת בכללי ברירת המחדל.",
	chatShareLocation: "שתף מיקום",
	chatSkipLabel: "דלג",
	chatSkippedLabel: "דולג",
	chatStartCall: "התחל שיחה",
	chatStartLiveSharing: "התחל שיתוף חי",
	chatStopLiveSharing: "עצור שיתוף חי",
	chatType: "סוג צ'אט",
	chatTypeToSearch: "הקלד כדי לחפש",
	chatTyping: "מקלידים...",
	chatUnnamedChat: "צאט ללא שם",
	chatUpdatingSharedLocationFor: "מעדכן מיקום משותף זה למשך",
	chatUploadGroupImage: "העלה תמונת קבוצה",
	chatUserInfo: "פרטי משתמש",
	chatUsersSaveFailed: "הוספת המשתמשים נכשלה",
	chatUsersSaveFailedTryAgain: "נסה להוסיף שוב את המשתמשים שנבחרו.",
	chatVenue: "מקום",
	chatVenueTitle: "כותרת מקום",
	chatVideoCall: "שיחת וידאו",
	chatViewReportedMessages: "הצג הודעות מדווחות",
	chatWaitingDeviceCoordinates: "ממתין לקואורדינטות המכשיר...",
	childcarePayment: "תשלום מעון ילדים",
	chooseBoard: "לוח נבחר כדי לצפות בקטגוריות ובמשימות שלו",
	cities: "ערים",
	city: "עיר",
	clear: "נקה",
	clearFilters: "נקה מסננים",
	clickTheButtonBelowToTakeTheNextStepOnYourJourney:
		"לחץ על הכפתור למטה כדי לקחת את הצעד הבא במסע שלך",
	contact: "לקוח",
	contactEngagement: "מעורבות לקוחות",
	contactGroup: "קבוצת לקוחות",
	contactGroups: "קהלי לקוחות",
	contactPlaylist: "רשימת השמעה של לקוח",
	contactProfile: "פרופיל לקוח",
	contacts: "לקוחות",
	contactsByGender: "לקוחות לפי מגדר",
	contactsByGroup: "לקוחות לפי קבוצה",
	contactsUsing: "לקוחות המשתמשים",
	contactsWithCarts: "לקוחות עם עגלות",
	contactsWithFavorites: "לקוחות עם מועדפים",
	clockInOut: "כניסה / יציאה",
	close: "סגור",
	closeNavigation: "סגור ניווט",
	closeTicket: "סגור כרטיס",
	closed: "סגור",
	closed_late: "נסגר לאחר המועד",
	closedDate: "תאריך סגירה",
	closedTickets: "כרטיסים סגורים",
	cmDashboard: "לוח בקרת תוכן",
	code: "קוד",
	coin: "מטבע",
	coinBurnTime: "זמן שריפת מטבע",
	coinCount: "מטבעות",
	color: "צבע",
	comment: "הערה",
	commentTicket: "הערת כרטיס",
	commissions: "עמלות",
	communicationPreferences: "העדפות תקשורת",
	community: "קהילה",
	company: "חברה",
	completed: "הושלם",
	completedDate: "תאריך סיום",
	completedTasks: "משימות שהושלמו",
	completionRate: "שיעור השלמה",
	confirm: "אשר",
	confirmAction: "אשר פעולה",
	contactForm: "טופס יצירת קשר",
	contactForms: "טופסי יצירת קשר",
	contactType: "סוג קשר",
	contacts: "אנשי קשר",
	contentByType: "תוכן לפי סוג",
	contentItems: "פריטי תוכן",
	contentManagementOverview: "סקירת מערכת ניהול תוכן",
	contentOverTime: "תוכן שנוצר לאורך זמן (30 הימים האחרונים)",
	continue: "להמשיך",
	contract: "חוזה",
	contractEndDate: "תאריך סיום החוזה",
	contractStartDate: "תאריך תחילת החוזה",
	contractor: "קבלן",
	copy: "העתק",
	costOfBuildingPart: "עלות חלק הבניין",
	costOfBuildingPermit: "עלות היתר בנייה",
	country: "מדינה",
	cpu: "מעבד",
	create: "הזמנה",
	createBoard: "יצירת לוח חדש",
	createChat: "צור צ'אט",
	createGroupChat: "צור צ'אט קבוצתי",
	createGroupSubmit: "צור",
	addNewCategory: "הוסף קטגוריה חדשה",
	createNewCategory: "יצירת קטגוריה חדשה",
	created: "נוצר",
	createdAt: "נוצר ב",
	createdBy: "נוצר על ידי",
	createdByUser: "נוצר על ידי משתמש",
	critical: "קריטי",
	crmDashboard: "לוח בקרת CRM",
	cta1: "קריאה לפעולה חלק 1",
	cta2: "קריאה לפעולה חלק 2",
	cta3: "קריאה לפעולה חלק 3",
	currency: "מטבע",
	currentlyStreaming: "משודר כעת",
	currentlyWorking: "עובד כעת",
	custom: "מותאם",
	customerAcquisition: "רכישת לקוחות",
	customerBaseOverview: "סקירת בסיס הלקוחות",
	customerInsights: "תובנות לקוחות",
	customerRelationshipOverview: "סקירת ניהול קשרי לקוחות",
	dashboard: "לוח בקרה",
	dashboardSubtitle: "כותרת משנה של לוח הבקרה",
	database: "בסיס נתונים",
	date: "תאריך",
	dateOfBirth: "תאריך לידה",
	dates: "תאריכים",
	datingAttendance: "נוכחות בדייטים",
	dayOff: "יום חופש",
	meeting: "פגישה",
	dayOffForAllEmployees: "יום חופש לכל העובדים",
	dayOffRemoved: "יום החופש הוסר",
	dayOffSavedForAllEmployees: "יום החופש נשמר לכל העובדים",
	days: "ימים",
	daysLeft: "ימים שנותרו",
	daysOfWeek: "ימים בשבוע",
	daysWorked: "ימי עבודה",
	deadLine: "מועד סיום",
	deadline: "מועד אחרון",
	debt: "חוב",
	decline: "לדחות",
	deductions: "ניכויים",
	defaultEnergyMax: "אנרגיה מקסימלית ברירת מחדל",
	defaultEnergyMin: "אנרגיה מינימלית ברירת מחדל",
	defaultStream: "זרם ברירת מחדל",
	defaultStreams: "זרמים ברירת מחדל",
	defaultStreamsDesc: "זרמים ברירת מחדל",
	delays: "עיכובים",
	delete: "למחוק",
	deleteForEveryone: "מחק לכולם",
	deletePermanently: "מחק לצמיתות",
	deleteRule: "מחיקת חוק",
	deleteSelected: "מחק נבחרים",
	delivery: "משלוח",
	deliveryAddress: "כתובת משלוח",
	deliveryMethod: "שיטת משלוח",
	density: "צפיפות",
	department: "מחלקה",
	departmentChatsHelp: "קשר צ'אטים קבוצתיים וערוצים למחלקה. זה מסתנכרן עם שדה המחלקה בכל צ'אט.",
	departmentLinkedChats: "צ'אטים של המחלקה",
	departments: "מחלקות",
	desc: "תיאור",
	description: "תיאור",
	designer: "מעצב",
	detailedFilters: "מסננים מפורטים",
	detailedSteps: "שלבים מפורטים",
	details: "פרטים",
	developed: "פותח",
	developedBy: "פותח על ידי",
	difference: "הבדל",
	diplomaImages: "תמונות תעודה",
	directMessages: "הודעות ישירות",
	disableSteps: "השבת שלבים",
	disabledSteps: "שלבים מושבתים",
	disk: "דיסק",
	distributionByPaymentType: "התפלגות לפי סוג תשלום",
	domainFacility: "מתקן",
	domainFinance: "פיננסים",
	domainHR: "HR",
	domainIT: "IT",
	domainOther: "אחר",
	domainSecurity: "אבטחה",
	done: "בוצע",
	download: "הורד",
	downloadAsContact: "הורד כאיש קשר",
	draft: "טיוטה",
	dragToReorder: "גרור לשינוי הסדר",
	dropFilesHere: "גרור קבצים לכאן",
	dropFilesHereOrClick: "גרור קבצים לכאן או לחץ להוספת עוד",
	dropzoneText: "גרור תמונות לכאן או לחץ לבחירת קבצים",
	dueDate: "תאריך סיום",
	duration: "משך זמן",
	ecommerceDashboard: "לוח בקרת דירוגים",
	edit: "ערוך",
	editComment: "ערוך הערה",
	editItem: "ערוך פריט",
	editProject: "ערוך פרויקט",
	editRule: "עריכת חוק",
	edited: "נערך",
	editingRule: "עריכת חוק",
	email: "אימייל",
	sendEmail: "שלח אימייל",
	employee: "עובד",
	employeesPerDepartment: "עובדים לפי מחלקות",
	employerExpenses: "הוצאות מעסיק",
	employmentStatus: "סטטוס תעסוקה",
	emptyTrash: "נקה אשפה",
	end: "סיום",
	endDate: "תאריך סיום",
	endDateMustBeLaterThanStartDate: "תאריך הסיום חייב להיות מאוחר יותר מתאריך ההתחלה",
	endDateShort: "תאריך סיום",
	endOfTraining: "סיום ההכשרה",
	endTime: "זמן סיום",
	ends: "נגמר",
	energyLevel: "רמת אנרגיה",
	energyScheduling: "תכנון אנרגיה",
	enterAmount: "הזן סכום",
	enterFeatureSuffix: "הזן סוניק תכונה",
	enterFeatureText: "הזן טקסט תכונה",
	enterGroupName: "הזן שם קבוצה...",
	enterLabel: "הזן תווית",
	enterPersons: "הזן מספר אנשים",
	enterRuleName: "הזן שם חוק",
	entry: "כניסה",
	error: "שגיאה",
	errorMessage: "התרחשה שגיאה, אנא נסה שוב.",
	errorOccurred: "התרחשה שגיאה",
	errorPageButton: "קח אותי הביתה",
	errorPageHelpText: "צריך עזרה? צור קשר עם צוות התמיכה שלנו",
	errorPageSecondaryButton: "דווח על בעיה זו",
	errorPageSubtitle: "הדף שאתה מחפש לא קיים",
	errorPageText:
		"אל תדאג, זה קורה לטובים ביותר! הדף אולי הועבר, נמחק, או אולי הקלדת כתובת URL שגויה. בואו נחזיר אותך למסלול הנכון.",
	errorPageTitle: "אופס! משהו השתבש",
	errorUserNotFound: "המשתמש לא נמצא",
	estimatedHours: "שעה נדרשת",
	eventType: "סוג אירוע",
	exit: "יציאה",
	expectedSalary: "שכר צפוי",
	expireDate: "תאריך תפוגה",
	expired: "פג תוקף",
	expiresOn: "פג תוקף",
	expiringIdCards: "תעודות זהות שפג תוקפן",
	expiringPassports: "דרכונים שפג תוקפם",
	export: "ייצוא",
	exportData: "ייצוא נתונים",
	extraLarge: "גדול מאוד",
	extraSmall: "קטן מאוד",
	faqQuestions: "שאלות נפוצות",
	favorites: "מועדפים",
	features: "תכונות",
	female: "נקבה",
	fields: "שדות",
	file: "קובץ",
	fileHasBeenRemoved: "הקובץ הוסר",
	fileMovedToTrash: "הקובץ נעבר לאשפה",
	fileRestored: "שוחזר",
	fileWillBeMovedToTrash: "הקובץ יועבר לאשפה",
	files: "קבצים",
	filesRestored: "שוחזרו קבצים",
	filesWillBePermanentlyDeleted: "קבצים יימחקו לצמיתות.",
	filter: "מסנן",
	filterBy: "מסנן",
	filters: "מסננים",
	finish: "סיים",
	fired: "פוטר",
	firstIn: "כניסה ראשונה",
	firstName: "שם פרטי",
	forgotPassword: "שכחת סיסמה?",
	forward: "העבר",
	forwardMessage: "העבר הודעה",
	forwarded: "הועבר",
	forwardedFrom: "הועבר מתוך",
	fri: "יום שישי",
	from: "מ",
	fromAttendanceLogs: "ממולא מיומני נוכחות לעובד ולתקופה; ניתן לשנות.",
	fromDb: "ממסד הנתונים",
	fromHrSettings: "הגדרות משאבי אנוש",
	gallery: "גלריה",
	genderDistribution: "הפצת מגדר",
	globalFilter: "מסנן גלובלי",
	globalSearchClose: "סגור",
	globalSearchCmd_goCalendar_desc: "אירועי לוח שנה",
	globalSearchCmd_goCalendar_label: "מעבר ללוח שנה",
	globalSearchCmd_goChat_desc: "פתיחת הודעות",
	globalSearchCmd_goChat_label: "מעבר לצ'אט",
	globalSearchCmd_goCrm_desc: "ניהול לקוחות",
	globalSearchCmd_goCrm_label: "מעבר ל-CRM",
	globalSearchCmd_goFinance_desc: "מודול כספים",
	globalSearchCmd_goFinance_label: "מעבר לכספים",
	globalSearchCmd_goHr_desc: "מודול משאבי אנוש",
	globalSearchCmd_goHr_label: "מעבר למשאבי אנוש",
	globalSearchCmd_goIt_desc: "ציוד IT",
	globalSearchCmd_goIt_label: "מעבר ל-IT",
	globalSearchCmd_goProjects_desc: "מסד נתוני פרויקטים",
	globalSearchCmd_goProjects_label: "מעבר לפרויקטים",
	globalSearchCmd_goRadio_desc: "מוזיקה ופלייליסטים",
	globalSearchCmd_goRadio_label: "מעבר לרדיו",
	globalSearchCmd_goTickets_desc: "מערכת כרטיסי תמיכה",
	globalSearchCmd_goTickets_label: "מעבר לכרטיסים",
	globalSearchCmd_goTodo_desc: "לוחות ומשימות",
	globalSearchCmd_goTodo_label: "מעבר ל-Todo",
	globalSearchCmd_messageUser_desc: "פתיחת צ'אט לשליחה",
	globalSearchCmd_messageUser_label: "הודעה למשתמש",
	globalSearchCmd_newContact_desc: "הוספת לקוח CRM",
	globalSearchCmd_newClient_label: "לקוח חדש",
	globalSearchCmd_newOrder_desc: "יצירת הזמנה",
	globalSearchCmd_newOrder_label: "הזמנה חדשה",
	globalSearchCmd_newProject_desc: "יצירת פרויקט",
	globalSearchCmd_newProject_label: "פרויקט חדש",
	globalSearchCmd_newTask_desc: "יצירת משימה",
	globalSearchCmd_newTask_label: "משימה חדשה",
	globalSearchCmd_newTicket_desc: "יצירת כרטיס תמיכה",
	globalSearchCmd_newTicket_label: "כרטיס חדש",
	globalSearchCommandBadge: "פקודה",
	globalSearchCommands: "פקודות",
	globalSearchCopied: "הועתק!",
	globalSearchCopyLink: "העתק קישור",
	globalSearchDirectMessage: "הודעה ישירה",
	globalSearchFilterAll: "הכול",
	globalSearchFilterCalendar: "לוח שנה",
	globalSearchFilterChats: "צ'אטים",
	globalSearchFilterDevices: "מכשירים",
	globalSearchFilterEcom: "מסחר אלקטרוני",
	globalSearchFilterFinance: "כספים",
	globalSearchFilterPeople: "אנשים",
	globalSearchFilterProjects: "פרויקטים",
	globalSearchFilterRadio: "רדיו",
	globalSearchFilterTickets: "כרטיסים",
	globalSearchFilterTodo: "משימות",
	globalSearchHidePreview: "הסתר תצוגה מקדימה",
	globalSearchNavigate: "ניווט",
	globalSearchOpen: "פתח",
	globalSearchOpenInNewTab: "פתח בלשונית חדשה",
	globalSearchPageBadge: "עמוד",
	globalSearchPlaceholder: "חפש כל דבר ב-APIT (משתמשים, כרטיסים, צ'אטים, מכשירים…)",
	globalSearchPreviewAddress: "כתובת",
	globalSearchPreviewArtist: "אמן",
	globalSearchPreviewChat: "צ'אט",
	globalSearchPreviewCompany: "חברה",
	globalSearchPreviewCreated: "נוצר",
	globalSearchPreviewDeviceId: "מזהה מכשיר",
	globalSearchPreviewEmail: "אימייל",
	globalSearchPreviewEmployeeNumber: "מספר עובד",
	globalSearchPreviewEnd: "סיום",
	globalSearchPreviewInfo: "מידע",
	globalSearchPreviewIp: "IP",
	globalSearchPreviewLocation: "מיקום",
	globalSearchPreviewMac: "MAC",
	globalSearchPreviewNumber: "מספר",
	globalSearchPreviewOrderNumber: "הזמנה מס'",
	globalSearchPreviewPhone: "טלפון",
	globalSearchPreviewSent: "נשלח",
	globalSearchPreviewStart: "התחלה",
	globalSearchPreviewUsername: "שם משתמש",
	globalSearchPreviewVendor: "ספק",
	globalSearchPreviewVersion: "גרסה",
	globalSearchRecentSearches: "חיפושים אחרונים",
	globalSearchRecentlyOpened: "נפתחו לאחרונה",
	globalSearchSectionArtists: "אמנים",
	globalSearchSectionAttendanceDevices: "מכשור נוכחות",
	globalSearchSectionBrands: "מותגים",
	globalSearchSectionCalendarEvents: "אירועי לוח שנה",
	globalSearchSectionCameras: "מצלמות",
	globalSearchSectionChats: "צ'אטים",
	globalSearchSectionClientGroups: "קבוצות לקוחות",
	globalSearchSectionClients: "לקוחות",
	globalSearchSectionCpus: "מעבדים",
	globalSearchSectionDepartments: "מחלקות",
	globalSearchSectionEcomCategories: "קטגוריות",
	globalSearchSectionFinanceCardIssuers: "מנפיקי כרטיסים",
	globalSearchSectionFinanceCards: "כרטיסים",
	globalSearchSectionFinanceCategories: "קטגוריות כספים",
	globalSearchSectionFinanceTransactions: "עסקאות",
	globalSearchSectionGpus: "כרטיסי מסך",
	globalSearchSectionKeyboards: "מקלדות",
	globalSearchSectionLaptops: "מחשבים ניידים",
	globalSearchSectionMessages: "הודעות",
	globalSearchSectionMice: "עכברים",
	globalSearchSectionMonitors: "מסכים",
	globalSearchSectionOrders: "הזמנות",
	globalSearchSectionPcs: "מחשבים",
	globalSearchSectionPlaylists: "פלייליסטים",
	globalSearchSectionPositions: "תפקידים",
	globalSearchSectionPrinters: "מדפסות",
	globalSearchSectionProblems: "בעיות",
	globalSearchSectionProducts: "מוצרים",
	globalSearchSectionProjects: "פרויקטים",
	globalSearchSectionRams: "זיכרון RAM",
	globalSearchSectionRoms: "אחסון",
	globalSearchSectionRooms: "חדרים",
	globalSearchSectionRouters: "נתבים",
	globalSearchSectionSmbs: "SMB",
	globalSearchSectionSoftware: "תוכנה",
	globalSearchSectionSwitches: "מתגים",
	globalSearchSectionTelephones: "טלפונים",
	globalSearchSectionTickets: "כרטיסים",
	globalSearchSectionTodoBoards: "לוחות",
	globalSearchSectionTodoCategories: "קטגוריות",
	globalSearchSectionTodoTasks: "משימות",
	globalSearchSectionTracks: "רצועות",
	globalSearchSectionUsers: "אנשים",
	globalSearchSectionWarrantyProviders: "ספקי אחריות",
	globalSearchSelectPreview: "בחרו פריט לתצוגה מקדימה",
	globalSearchShortcutHint: "Ctrl + K",
	globalSearchShowPreview: "הצג תצוגה מקדימה",
	globalSearchSubtitle: "חיפוש בכל המודולים",
	globalSearchSuggest1: "חיפוש כרטיסים שהוקצו לי",
	globalSearchSuggest2: "מציאת עובד לפי אימייל",
	globalSearchSuggest3: "חיפוש בהודעות צ'אט",
	globalSearchSuggest4: "מציאת מכשיר לפי IP",
	globalSearchSuggest5: "חיפוש לקוח לפי טלפון",
	globalSearchSuggest6: "מעבר לפרויקטים",
	globalSearchTrySearchingFor: "נסו לחפש",
	goBack: "חזור",
	goToMessage: "מעבר להודעה",
	goToUserAttendanceTab: "משתמשים → נוכחות",
	goToUserAttendanceTabTooltip: "פתיחת העובד בדף משתמשי משאבי אנוש בלשונית נוכחות",
	gpu: "מעבד גרפי",
	grossSalary: "שכר ברוטו",
	group: "קבוצה",
	groupChat: "צ'אט קבוצתי",
	groupChatWritePermissionDescription: "כל המשתתפים בצ'אט יכולים לכתוב הודעות",
	groupChats: "צ'אטים קבוצתיים",
	groupName: "שם הקבוצה (אופציונלי)",
	healthInsurance: "ביטוח בריאות",
	healthInsuranceBenefit: "ביטוח בריאות (הטבה)",
	help: "עזרה",
	hideAllSteps: "הסתר את כל השלבים",
	hideHistory: "הסתר היסטוריה",
	hideProjectDetails: "הסתר פרטי פרויקט",
	hideTableColumnFilters: "הסתרת מסנני עמודות",
	hideTimeline: "הסתר ציר זמן",
	high: "גבוה",
	highestSpendingCustomers: "לקוחות עם ההוצאה הגבוהה ביותר",
	highlight: "הדגשה",
	highlightFeature: "הדגשת תכונה",
	history: "היסטוריה",
	historyTable: "טבלת היסטוריה",
	holiday: "חג",
	holidayNonWorking: "חג / יום לא עבודה",
	hourlyRate: "שכר שעתי",
	hourlyRateBaseLinked: "מעדכן שכר בסיס משכר שעתי × שעות רגילות (כששעות > 0).",
	hr2025RateReferenceTables: "טבלאות שיעורי ייחוס 2025",
	hrAccrualAnnualTotal: "סה״כ שנתי: {amount} ימים",
	hrAccrualDaily: "יומי (÷ 365)",
	hrAccrualEachDay: "כל יום: +{amount} ימי חופשה",
	hrAccrualEachMonthFirst: "ב-1 לכל חודש: +{amount} ימי חופשה",
	hrAccrualMethod: "שיטת צבירה",
	hrAccrualMethodDesc: "כיצד נצברת חופשה",
	hrAccrualMonthly: "חודשי (÷ 12, ב-1 לחודש)",
	hrAccrualMonthlyEquivalent: "שקול חודשי: ~{amount} ימים",
	hrAccrualPreview: "תצוגה מקדימה של צבירה",
	hrArmeniaIncomeTaxCalculator: "מחשבון מס הכנסה ארמניה",
	hrArmeniaTaxRates: "שיעורי מס בארמניה",
	hrCalcSummaryGrossToNet:
		"עבור שכר רשום של {gross} AMD, לאחר ניכוי {deductions} AMD במסים ובהפרשות תקבלו {net} AMD ליד.",
	hrCalcSummaryNetToGross: "כדי לקבל {net} AMD ליד, חוזה העבודה חייב להציג ברוטו {gross} AMD.",
	hrCalculationBreakdown: "פירוט חישוב",
	hrCalculationDirection: "כיוון חישוב",
	hrDefaultBenefitsDescription: "ברירות מחדל אלה חלות על כל חישובי השכר אלא אם הוגדר אחרת לעובד.",
	hrDefaultMonthlyBenefits: "הטבות חודשיות ברירת מחדל (AMD)",
	hrDesiredNetSalaryLabel: "שכר נטו רצוי (ליד)",
	hrEmployeePensionLabel: "פנסיה לעובד:",
	hrEmployeePensionRate: "שיעור פנסיה לעובד",
	hrEmployeePensionRateDesc: "חובה לנולדים אחרי 1973 (2.5%)",
	hrEmployerPensionRate: "שיעור פנסיה למעסיק",
	hrEmployerPensionRateDesc: "הפרשה פנסיונית של המעסיק (2.5%)",
	hrFailedToSaveSettings: "שמירת ההגדרות נכשלה",
	hrGrossSalaryAMD: "שכר ברוטו (AMD)",
	hrGrossSalaryDescription: "הזן את הסכום המופיע בחוזה העבודה",
	hrGrossSalaryLabel: "שכר ברוטו (רשום / סכום חוזה)",
	hrGrossSalaryRegistered: "שכר ברוטו (רשום)",
	hrGrossToNet: "ברוטו ← נטו",
	hrHealthInsuranceAges: "ביטוח בריאות (גילאים 18–65)",
	hrHealthInsuranceBenefit: "ביטוח בריאות",
	hrHealthInsuranceBenefitDesc: "הפרשה חודשית של המעסיק לביטוח בריאות (AMD)",
	hrHealthInsuranceEmployeeColumn: "עובד",
	hrHealthInsuranceEmployeeShare: "ביטוח בריאות (חלק העובד)",
	hrHealthInsuranceStateColumn: "מדינה",
	hrITSector: "מגזר IT (מס הכנסה 10%)",
	hrITSectorDesc: "עובד בחברת IT בעלת רישיון",
	hrIncomeTax: "מס הכנסה",
	hrIncomeTaxLabel: "מס הכנסה:",
	hrIncomeTaxRate: "שיעור מס הכנסה",
	hrIncomeTaxRateDesc: "שיעור שטוח 20% בארמניה מאז 2020",
	hrLeaveAccrualConfiguration: "הגדרת צבירת חופשה",
	hrLiveRates: "שיעורים עדכניים",
	hrLunchCoverage: "כיסוי ארוחת צהריים",
	hrLunchCoverageDesc: "מענק ארוחת צהריים חודשי (AMD)",
	hrMandatoryHealthInsurance: "ביטוח בריאות חובה (18–65)",
	hrMandatoryHealthInsuranceDesc: "כלול שכבות ביטוח בריאות 2025",
	hrMilitaryStampRate: "שיעור אגרה צבאית",
	hrMilitaryStampRateDesc: "השאר 0 אם לא רלוונטי",
	hrMonthlyFee: "תשלום חודשי",
	hrNetSalaryDescription: "הזן כמה ברצונך לקבל ליד",
	hrNetSalaryLabel: "שכר נטו:",
	hrNetSalaryTakeHome: "שכר נטו (ליד)",
	hrNetToGross: "נטו → ברוטו",
	hrOvertimeRateMultiplier: "מכפיל תעריף שעות נוספות",
	hrOvertimeRateMultiplierDesc: "למשל 1.5× = פרמיה של 50% לשעות נוספות",
	hrOvertimeRules: "כללי שעות נוספות",
	hrBreakIntervals: "הפסקות",
	hrBreakIntervalsDesc:
		"חלונות זמן קבועים יומיים (למשל ארוחת צהריים) שאינם נספרים בשעות העבודה עבור כולם. ניתן להוסיף יותר מאחת.",
	hrBreakIntervalsEmpty: "לא הוגדרו הפסקות",
	hrBreakIntervalStart: "תחילת הפסקה",
	hrBreakIntervalEnd: "סוף הפסקה",
	hrAddBreakInterval: "הוסף הפסקה",
	hrOvertimeThreshold: "סף שעות נוספות (שעות/יום)",
	hrOvertimeThresholdDesc: "שעות מעבר לכך מחושבות לפי תעריף שעות נוספות",
	hrPensionMandatory: "חובה / התנדבותי לפני 07/2018 (5%)",
	hrPensionNone: "לא משתתף (0%)",
	hrPensionPost2018: "התנדבותי אחרי 07/2018 (5%)",
	hrPensionSystem: "מערכת פנסיה",
	hrPensionSystemDesc: "סטטוס השתתפותכם בפנסיה ממומנת",
	hrSettingsPageSubtitle: "הגדרת שכר, חופשות וכללי נוכחות",
	hrSettingsPageTitle: "הגדרות משאבי אנוש",
	hrSettingsUpdatedSuccessfully: "הגדרות משאבי אנוש עודכנו בהצלחה",
	hrSickDaysPerYear: "ימי מחלה בשנה",
	hrSickDaysPerYearDesc: "ימי מחלה בתשלום לשנה קלנדרית",
	hrSocialPaymentPension: "תשלום סוציאלי (פנסיה)",
	hrSocialTaxRate: "שיעור מס סוציאלי",
	hrSocialTaxRateDesc: "כיום 0% בארמניה (הוחלף בפנסיה)",
	hrStampFee: "אגרת בול (קרן ביטוח צבאי)",
	hrStampFeeTooltip: "קרן ביטוח צבאי — אגרה קבועה לפי מדרג שכר ברוטו",
	hrStandardWorkSchedule: "לוח זמנים סטנדרטי",
	hrStateHealthContribution: "השתתפות המדינה בבריאות",
	hrStateHealthContributionNote: "נוסף על ידי המדינה לחבילת הביטוח (לא מנוכה מהשכר).",
	hrSuffixDays: "ימים",
	hrSuffixHours: "ש׳",
	hrSuffixTimes: "×",
	hrSummary: "סיכום",
	hrTabDefaultBenefits: "הטבות ברירת מחדל",
	hrTabLeaveAccrual: "צבירת חופשה",
	hrTabTaxCalculator: "מחשבון מס",
	hrTabTaxesArmenia: "מסים (ארמניה)",
	hrTabWorkSchedule: "לוח זמנים לעבודה",
	hrTaxPreviewTitle: "תצוגה מקדימה של מס (על 500,000 AMD ברוטו)",
	hrTaxRatesDescription: "השיעורים חלים על ברוטו. הזן באחוזים (למשל 20 = 20%).",
	hrTaxRatesDisclaimer:
		"שיעורים לפי חוק ארמניה 2025–2026. מס הכנסה: 20% סטנדרטי, 10% לחברות IT ברישיון. פנסיה: 5% (חובה/התנדבותי לפני 2018) או 5% קבוע (התנדבותי אחרי 2018). שיעור 10% העודף חל על משתתפי חובה/לפני 2018 מעל 500,000 AMD. אמת עם רואה חשבון מוסמך.",
	hrThresholdWarning: "אזהרת סף",
	hrThresholdWarningText:
		"השכר שלכם קרוב לסף מדרג (100k / 200k / 500k / 1M AMD). בנקודות אלה אגרה וביטוח קופצים למדרגה גבוהה יותר, כך שעלייה קטנה בברוטו עלולה להקטין נטו. המחשבון תמיד מציג את המינימום ברוטו לנטו המבוקש.",
	hrTickets: "כרטיסי HR",
	hrTotalDeductions: "סה״כ ניכויים",
	hrTotalEmployeeDeductionsLabel: "סה״כ ניכויים לעובד:",
	hrTransportAllowance: "מענק תחבורה",
	hrTransportAllowanceDesc: "הטבת תחבורה חודשית (AMD)",
	hrVacationDaysPerYear: "ימי חופשה בשנה",
	hrVacationDaysPerYearDesc: "זכאות שנתית מלאה (מינימום בארמניה: 20)",
	hrWorkingDayEnd: "סיום יום העבודה",
	hrWorkingDayEndDesc: "שעת סיום משמרת צפויה. שעות יומיות נגזרות משעות ההתחלה/סיום",
	hrWorkingDayStart: "תחילת יום העבודה",
	hrWorkingDayStartDesc: "שעת הגעה צפויה לבדיקות נוכחות ואיחורים",
	hrWeekendDays: "ימי סוף שבוע",
	hrWeekendDaysDesc: "בחר אילו ימים בשבוע נחשבים לימי סוף שבוע שאינם ימי עבודה",
	hrWorkingDaysPerWeek: "ימי עבודה בשבוע",
	hrWorkingDaysPerWeekDesc: "ב׳–ו׳ = 5, ב׳–ש׳ = 6",
	hrWorkingHoursPerDay: "שעות עבודה ביום",
	hrWorkingHoursPerDayDesc: "שעות סטנדרטיות לפני שעות נוספות",
	href: "קישור",
	humanResources: "משאבי אנוש",
	id: "מזהה",
	idCard: "תעודת זהות",
	idCardEndDate: "תאריך סיום כרטיס זיהוי",
	idCardNo: "מספר כרטיס זיהוי",
	idCardStartDate: "תאריך תחילת כרטיס זיהוי",
	idCart: "כרטיס זיהוי",
	image: "תמונה",
	immediateSupervisor: "מנהל ישיר",
	importance: "חשיבות",
	important: "חשוב",
	inProgress: "בתהליך",
	inSelectedPeriod: "בתקופה שנבחרה",
	inStock: "במלאי",
	in_progress: "בתהליך",
	inactive: "לא פעיל",
	inactiveTime: "זמן לא פעיל",
	incident: "אירוע",
	incomeTaxAmount: "סכום מס הכנסה",
	incomeTaxRate: "שיעור מס הכנסה (%)",
	incomingCall: "שיחה נכנסת",
	incomingVideoCall: "שיחת וידאו נכנסת",
	incorrectLogin: "הכנסת שם משתמש או סיסמה לא נכונה",
	index: "#",
	inputInArmenian: "הכנס בארמנית",
	inputInLatin: "הקלד בלטינית",
	inputInNumbers: "הזן במספרים",
	inputInRussian: "הכנס ברוסית",
	inputNumber: "הכנס מספר",
	inputNumbers: "הזן מספרים",
	instagramPosts: "פוסטים באינסטגרם",
	insufficientVacationBalance: "יתרת חופשה לא מספיקה",
	interview1: "ראיון",
	interview2: "היכרות",
	interview3: "הכשרה",
	interview4: "התמחות",
	interviewDate: "תאריך ריאיון",
	interviewTime: "שעת ריאיון",
	introSection: "חלק הקדמה",
	invalidDate: "תאריך מספק שגוי",
	inventorySummary: "סיכום מלאי",
	ip: "IP",
	ipAddress: "כתובת IP",
	isActive: "פעיל",
	isColor: "צבע",
	isPrivateOffice: "האם משרד פרטי",
	isPublic: "عمومי",
	itTickets: "כרטיסי IT",
	items: "פריטים",
	justifiedAbsence: "היעדרות מוצדקת",
	keyText: "טקסט מפתח",
	keyboards: "מקלדות",
	label: "תווית",
	language: "שפה",
	languagePickerLabel: "שפה",
	large: "גדול",
	last7Days: "התחברו ב-7 הימים האחרונים",
	lastAction: "הפעולה האחרונה",
	lastLogin: "התחברות אחרונה",
	lastName: "שם משפחה",
	lastOut: "יציאה אחרונה",
	lastPunch: "נוכחות אחרונה",
	lasts: "משך זמן",
	latestCustomerOrders: "הזמנות לקוחות אחרונות",
	leader: "מַנהִיג",
	attendanceManagersFilter: "מנהלים",
	attendanceLeadersFilter: "מובילים",
	leaveBalance: "יתרת חופשה",
	linkCopied: "הקישור הועתק",
	listeners: "מאזינים",
	livingAddress: "כתובת מגורים",
	loading: "טוען",
	loanDeductions: "ניכויי הלוואה",
	localCode: "קוד מקומי",
	logOut: "התנתק",
	login: "התחברות",
	loginButton: "התחברות",
	loginFailed: "הכניסה נכשלה",
	loginFailedMessage: "אנא בדוק את פרטי הכניסה שלך",
	loginSuccess: "הכניסה הצליחה",
	loginSuccessMessage: "נכנסת בהצלחה",
	loginToStartSession: "התחבר כדי להתחיל סשן",
	logout: "התנתק",
	low: "נמוך",
	lunchCoverage: "כיסוי ארוחת צהריים",
	mac: "MAC",
	macAddress: "כתובת MAC",
	main: "ראשי",
	itHierarchyAddLaptop: "הוספת מחשב נייד",
	itHierarchyAttachedPc: "מחשב מחובר",
	itHierarchyLaptopsUsingPart: "מחשבים ניידים המשתמשים ברכיב זה",
	itUsedInOtherPlaces: "בשימוש במקומות אחרים",
	mainInformation: "מידע בסיסי",
	mainInfo: "מידע עיקרי",
	contactInfo: "פרטי קשר",
	personalInfo: "מידע אישי",
	workingInfo: "מידע תעסוקתי",
	probation: "תקופת ניסיון",
	educationInfo: "מידע השכלתי",
	male: "זכר",
	manualAdjustments: "התאמות ידניות",
	manualAttendanceEntry: "הזנה ידנית",
	maps: "מפות",
	maritalStatus: "מצב משפחתי",
	markAllAsRead: "סמן הכל כנקרא",
	markSelectedAsRead: "סמן נבחרים כנקרא",
	maternityLeave: "חופשת לידה",
	maxEnergy: "אנרגיה מקסימלית",
	maxFilesReached: "המספר המקסימלי של קבצים הושך",
	maxSize: "גודל מרבי",
	mediaGallery: "גלרית מדיה",
	mediaGalleryDescription: "תיאור גלרית מדיה",
	mediator: "בינות",
	medium: "בינוני",
	members: "חברים",
	menu: "תפריט",
	message: "הודעה",
	messages: "הודעות",
	messagesByType: "הודעות לפי סוג",
	messagesOverTime: "הודעות לאורך זמן (30 הימים האחרונים)",
	militaryStampAmount: "סכום אגרת בול צבאי",
	militaryStampRate: "שיעור אגרת בול צבאי",
	minEnergy: "אנרגיה מינימלית",
	minute: "דקה",
	minutes: "דקות",
	missingInterval: "מרווח חסר",
	mon: "יום שני",
	monitor: "מסך",
	monitors: "מוניטורים",
	month: "חודש",
	monthly: "חודשי",
	mood: "הדגם",
	more: "נוסף",
	moreDetailed: "יותר מפורט",
	moreThan: "יותר מ",
	motherProject: "פרויקט אם",
	mounted: "מותקן",
	mouses: "עכברים",
	moveToTrash: "העבר לאשפה",
	movedToTrash: "העבר לאשפה",
	myActiveSteps: "השלבים הפעילים שלי",
	myInvolvement: "המעורבות שלי",
	myProjects: "הפרויקטים שלי",
	myRole: "התפקיד שלי",
	mySteps: "השלבים שלי",
	myTickets: "הכרטיסים שלי",
	na: "לא זמין",
	name: "שם",
	netCash: "נטו במזומן",
	netOfficial: "נטו רשמי",
	netSalary: "שכר בריא",
	newClients: "לקוחות חדשים",
	newClientsOverTime: "לקוחות חדשים לאורך זמן (30 הימים האחרונים)",
	newMessage: "הודעה חדשה",
	newProducts: "מוצרים חדשים",
	newProject: "פרויקט חדש",
	newProjects: "פרויקטים חדשים",
	newThisPeriod: "חדש בתקופה זו",
	newTicket: "כרטיס חדש",
	newTicketCreatedBy: "כרטיס חדש נוצר על ידי",
	newTracks: "שירים חדשים",
	newTracksOverTime: "שירים חדשים לאורך זמן (30 הימים האחרונים)",
	next: "הבא",
	nextComposition: "הרכב הבא",
	nextStep: "שלב הבא",
	noAccess: "אין גישה",
	noActiveSteps: "אין שלבים פעילים",
	noBoardsFound: "לוחות לא נמצאו",
	noCategoriesFound: "קטגוריות לא נמצאו",
	noCategoryDataAvailable: "אין נתוני קטגוריה זמינים",
	noContent: "אין תוכן",
	noCustomerDataAvailable: "אין נתוני לקוחות זמינים",
	noData: "אין נתונים",
	noDataAvailable: "אין נתונים זמינים",
	noDataAvailableForSelectedPeriod: "אין נתונים זמינים לתקופה שנבחרה",
	noDepartment: "אין מחלקה",
	noDepartments: "אין מחלקות",
	noDescription: "תיאור לא נמצא",
	noEmail: "אין אימייל",
	noExpiringIdCards: "אין כרטיסי זיהוי שפג תוקפם",
	noExpiringPassports: "אין דרכונים שפג תוקפם",
	noGroup: "ללא קבוצה",
	noMediaDescription: "תיאור מדיה לא נמצא",
	noMediaFound: "מדיה לא נמצאה",
	noMoreItems: "אין עוד פריטים",
	noName: "ללא שם",
	noNeedStep45: "לא צריך שלב 4-5",
	noNotifications: "אין התראות",
	noOrdersInSelectedPeriod: "אין הזמנות בתקופה שנבחרה",
	noOvertimeRecords: "לא נמצאו רשומות שעות נוספות",
	noPaymentDataAvailable: "אין נתוני תשלום זמינים",
	noProjectsAssigned: "אין פרויקטים שהוקצו",
	noProjectsAssignedOrInvolved: "אין פרויקטים שהוקצו או מעורבים",
	noRecentContacts: "אין לקוחות אחרונים",
	noRecentContent: "אין תוכן אחרון",
	noRecentTickets: "אין כרטיסים אחרונים",
	noRecentTracks: "אין שירים אחרונים",
	noRecipientInformation: "אין מידע על הנמען",
	noResponsible: "אין אחראי",
	noResult: "לא נמצאו תוצאות",
	noResults: "לא נמצאו תוצאות",
	noResultsFound: "לא נמצאו תוצאות",
	noRulesAdded: "חוקי תכנון לא נוספו",
	noStatusData: "אין נתוני סטטוס",
	noSystemDaysOffThisMonth: "אין ימי חופשה מערכתיים החודש",
	noTaskDataAvailable: "אין נתוני משימות זמינים",
	noTasksYet: "אין משימות עדיין",
	noTasksYetDescription: "אין משימות עדיין",
	noUpcomingBirthdays: "אין ימי הולדת קרובים",
	noUsersFound: "לא נמצאו משתמשים",
	noUsersInDepartment: "אין משתמשים במחלקה זו",
	noWorkHourData: "אין נתוני שעות עבודה",
	no_priority: "ללא עדיפות",
	nonWorking: "יום לא עבודה",
	none: "ללא",
	notAvailable: "המוצר אינו זמין",
	notCorrectLoginCredentials: "פרטי התחברות שגויים",
	notLoggedInToday: "לא נכנס היום",
	notPlaced: "לא מוצב",
	notPresent: "לא נוכח",
	notResponded: "לא נענה",
	notWorking: "לא עובד",
	deviceProblems: "בעיות מכשירים",
	openTickets: "כרטיסים פתוחים",
	note: "הערה",
	nothingFound: "לא נמצא כלום",
	notifications: "הודעות",
	notificationsBellAria: "פתח התראות",
	similarTicketNotifications: "התראות על כרטיסים דומים",
	number: "מספר",
	"office-map": "מפת משרד",
	officeMapActivatePlacement: "הפעל מיקום",
	officeMapAgent: "סוכן",
	officeMapAll: "הכול",
	officeMapAttendanceDevice: "מכשיר נוכחות",
	officeMapAttendanceDevices: "נוכחות",
	officeMapCable: "כבל",
	officeMapCableLinePlaced: "קו הכבל מוקם",
	officeMapCableRemovedFromMap: "הכבל הוסר מהמפה",
	officeMapCables: "כבלים",
	officeMapCamera: "מצלמה",
	officeMapCameras: "מצלמות",
	officeMapNvr: "מקליט וידאו ברשת (NVR)",
	officeMapChat: "צ'אט",
	officeMapChatWasNotCreated: "הצ'אט לא נוצר",
	officeMapConnectToCamera: "התחבר למצלמה",
	officeMapCpu: "CPU",
	officeMapDeactivate: "השבת",
	officeMapDeviceDetails: "פרטי מכשיר",
	officeMapDeviceId: "מזהה מכשיר",
	officeMapDisableDragging: "השבת גרירה",
	officeMapEnableDragging: "הפעל גרירה",
	officeMapEndDeviceOptional: "מכשיר סיום (אופציונלי)",
	officeMapFailedToMoveCable: "העברת הכבל נכשלה",
	officeMapFailedToMoveItem: "העברת הפריט נכשלה",
	officeMapFailedToMoveRoomArea: "העברת אזור החדר נכשלה",
	officeMapFailedToOpenChat: "פתיחת הצ'אט נכשלה",
	officeMapFailedToPlaceItem: "מיקום הפריט נכשל",
	officeMapFailedToPlaceUser: "מיקום המשתמש נכשל",
	officeMapFailedToRemoveCable: "הסרת הכבל נכשלה",
	officeMapFailedToRemoveItem: "הסרת הפריט נכשלה",
	officeMapFailedToRemoveRoomArea: "הסרת אזור החדר נכשלה",
	officeMapFailedToSaveCableLine: "שמירת קו הכבל נכשלה",
	officeMapFailedToSaveRoomArea: "שמירת אזור החדר נכשלה",
	officeMapFinishArea: "סיים אזור",
	officeMapFinishCable: "סיים כבל",
	officeMapForbidden: "אסור",
	officeMapIp: "IP",
	officeMapItem: "פריט",
	officeMapItemPlaced: "הפריט מוקם",
	officeMapItemRemovedFromMap: "הפריט הוסר מהמפה",
	officeMapLaptop: "מחשב נייד",
	officeMapLaptops: "מחשבים ניידים",
	officeMapLayers: "שכבות",
	officeMapLinkedItRoom: "חדר IT מקושר",
	officeMapLive: "חי",
	officeMapMac: "MAC",
	officeMapMin: "מינ׳",
	officeMapMonitors: "מסכים",
	officeMapNetworkCable: "כבל רשת",
	officeMapNoDevicesInArea: "אין מכשירים או משתמשים שמוקמו באזור זה.",
	officeMapNoPermissionToPlaceItem: "אין לך הרשאה למקם פריט זה.",
	officeMapNoPermissionToPlaceNetworkCable: "אין לך הרשאה למקם כבל רשת.",
	officeMapNoPermissionToPlaceRoomArea: "אין לך הרשאה למקם אזור חדר.",
	officeMapNoPermissionToRemoveItem: "אין לך הרשאה להסיר פריט זה מהמפה.",
	officeMapNoPermissionToRemoveNetworkCable: "אין לך הרשאה להסיר את כבל הרשת מהמפה.",
	officeMapNoPermissionToRemoveRoomArea: "אין לך הרשאה להסיר את אזור החדר מהמפה.",
	officeMapNotAvailable: "לא זמין",
	officeMapNotConnected: "לא מחובר",
	officeMapPc: "מחשב",
	officeMapPcs: "מחשבים",
	officeMapPlacement: "מיקום",
	officeMapPleaseSelectItemFirst: "אנא בחר פריט תחילה",
	officeMapPleaseSelectRoomFirst: "אנא בחר חדר תחילה",
	officeMapPoints: "נקודות",
	officeMapPorts: "יציאות",
	officeMapPrinted: "הודפס",
	officeMapPrinters: "מדפסות",
	officeMapRam: "RAM",
	officeMapRemoveFromMap: "הסר מהמפה",
	officeMapRom: "ROM",
	officeMapRoomArea: "אזור חדר",
	officeMapRoomAreaPlaced: "אזור החדר מוקם",
	officeMapRoomAreaRemovedFromMap: "אזור החדר הוסר מהמפה",
	officeMapRoomAreas: "חדרים",
	officeMapRoomContents: "תוכן החדר",
	officeMapRouter: "נתב",
	officeMapRouters: "נתבים",
	officeMapSelectItem: "בחר פריט",
	officeMapSelectRoom: "בחר חדר",
	officeMapSpeed: "מהירות",
	officeMapStartDeviceOptional: "מכשיר התחלה (אופציונלי)",
	officeMapSwitches: "סוויצ'ים",
	officeMapTelephone: "טלפון",
	officeMapTelephones: "טלפונים",
	officeMapUnknown: "לא ידוע",
	officeMapUrl: "URL",
	officeMapUserPlacedOnMap: "המשתמש מוקם על המפה",
	officeMapUsers: "משתמשים",
	officeMapViewContents: "הצג תוכן",
	officeMapViewFullDetails: "הצג פרטים מלאים",
	offline: "לא מקוון",
	offlinePaymentOnly: "תשלום לא מקוון בלבד",
	oldProject: "פרויקט ישן",
	onSale: "במכירה",
	onSecond: "בשנייה",
	onTime: "בזמן",
	onTimeRate: "שיעור הגעה בזמן",
	oneOf: "אחד מ",
	open: "פתח",
	openBoard: "פתיחת לוח",
	openDate: "תאריך פתיחה",
	openInModal: "פתח בחלון מודל",
	openInNewTab: "פתיחה בלשונית חדשה",
	openNavigation: "פתח ניווט",
	openedDate: "תאריך פתיחה",
	optional: "אופציונלי",
	orClickToSelect: "או לחץ לבחירת קבצים",
	order: "הזמנה",
	orderNumber: "מספר הזמנה",
	orders: "הזמנות",
	ordersCart: "תרשים הזמנות",
	otAfterWork: "שעות נוספות אחרי העבודה",
	otBeforeWork: "שעות נוספות לפני העבודה",
	otherBenefits: "הטבות נוספות",
	otherDeductions: "ניכויים אחרים",
	otherInsurance: "ביטוח אחר",
	outOfStock: "אזל מהמלאי",
	overdue: "באיחור",
	overtimeComment: "הערה לשעות נוספות",
	overtimeDays: "ימי שעות נוספות",
	overtimeHours: "שעות נוספות",
	overtimeRate: "תעריף שעות נוספות",
	overtimeSummary: "סיכום שעות נוספות",
	overtimeTotal: "סך כל שעות הנוספות",
	overview: "סקירה",
	owner: "בעל",
	ownership: "יחסי בעלות",
	pageNotFound: "הדף לא נמצא",
	pageNotFoundDescription:
		"אופס! הדף שאתה מחפש לא קיים או הועבר. ייתכן שהוא הוסר, שמו שונה או שהוא זמנית לא זמין.",
	pages: "דפים",
	paid: "שולם",
	paidStatus: "סטטוס תשלום",
	paidTimeOff: "חופשה בתשלום",
	paidTimeOffDays: "ימי חופשה בתשלום",
	parent: "הורה",
	parentCategory: "קטגורית הורה",
	parentDepartment: "מחלקה הורה",
	parentTask: "משימת אב",
	parentType: "סוג הורה",
	parentUser: "משתמש הורה",
	participant: "משתתף",
	passportEndDate: "תאריך פקיעת דרכון",
	passportImages: "תמונות דרכון",
	passportNo: "מספר דרכון",
	passportStartDate: "תאריך הנפקת דרכון",
	password: "סיסמה",
	pause: "השהה",
	paused: "מושהה",
	payDate: "תאריך תשלום",
	paymentMethod: "שיטת תשלום",
	paymentMethods: "אמצעי תשלום",
	paymentSystem: "מערכת תשלום",
	payrollBreakdown: "פירוט תלוש השכר",
	payrollCalcError: "חישוב השכר נכשל.",
	payrollCalcHint: "עובד ותקופה הם שדות חובה. לחץ לחישוב ושמירת סכומי השכר.",
	payrollCalcMissingFields: "נא לבחור עובד, תאריך התחלה ותאריך סיום של התקופה.",
	payrollCommentsForEmployee: "הערות לעובד",
	payrollGeneratedFromAttendance: "חישוב שכר שנוצר מנוכחות",
	payrollHealthInsurancePremium: "ביטוח בריאות (פרמיה)",
	payrollIndexLabel: "מספר",
	payrollIndexPlaceholder: "מדד",
	payrollInternalNotes: "הערות פנימיות",
	payrollNotesSection: "הערות",
	payrollType: "סוג תלוש שכר",
	payrollUsesHrSettings:
		"שעות נוספות, שיעורי מס והטבות ברירת מחדל (ארוחה, תחבורה, בריאות) לפי הגדרות משאבי אנוש (מערכת → הגדרות משאבי אנוש).",
	pc: "מחשב",
	pcHealth: "בריאות המחשב",
	pcs: "מחשבים",
	pdf: "PDF",
	penalties: "קנסות",
	pending: "ממתין",
	pensionAmount: "סכום פנסיה",
	pensionRate: "שיעור פנסיה",
	periodEnd: "זמן סיום",
	periodStart: "זמן התחלה",
	permInput_calendarEvent_overlayCustomCalendars: "יומנים מותאמים (מסננים)",
	permInput_calendarEvent_overlayIt: "יומני IT (אחריות מחשב)",
	permInput_calendarEvent_overlayPeople: "יומני אנשים (משאבי אנוש)",
	permInput_calendarEvent_overlayReminders: "שכבת תזכורות",
	permInput_calendarEvent_overlayTasks: "משימות (שכבות עדיפות)",
	permInput_calendarEvent_overlayTickets: "שכבת קריאות (דדליין לפי תחום)",
	permInput_chat_attachFile: "צירוף קבצים",
	permInput_chat_calling: "שיחות קוליות",
	permInput_chat_pin: "נעיצת הודעות",
	permInput_chat_searchFiles: "חיפוש בקבצים",
	permInput_chat_searchMessages: "חיפוש בהודעות",
	permInput_chat_sendMessage: "שליחת הודעות",
	permInput_chat_star: "סימון הודעות בכוכב",
	permInput_chat_videoCalling: "שיחות וידאו",
	permModuleCrud_download: "הורדת לוח שנה (ייבוא .ics)",
	permModuleCrud_upload: "העלאת לוח שנה (ייצוא .ics)",
	permanentDelete: "מחיקה לצמיתות?",
	permission: "הרשאה",
	permissions: "הרשאות",
	persons: "אנשים",
	phone: "טלפון",
	photo: "תמונה",
	photos: "תמונות",
	pickEmoji: "בחר אמוג'י",
	pinnedMessages: "הודעות מוצמדות",
	placed: "מוצב",
	placedState: "מצב מוצב",
	placeholder: "מַקום מְשׁוּחר",
	platformDashboard: "לוח בקרה של פלטפורמה",
	platformSpecificSettings: "הגדרות ספציפיות לפלטפורמה",
	platforms: "פלטפורמות",
	audioPlaybackSpeed: "מהירות הפעלה: {rate}. לחץ לשינוי.",
	playbackMute: "השתק",
	playbackUnmute: "בטל השתקה",
	playbackVoiceMessage: "הודעה קולית",
	playbackVideoMessage: "הודעת וידאו",
	previewVoiceMessage: "תצוגה מקדימה של ההודעה הקולית",
	play: "נגן",
	playStatus: "מצב השמעה",
	playing: "נגן",
	playingComposition: "הרכב מנוגן",
	playingHistory: "היסטוריית השמעה",
	playlist: "רשימת השמעה",
	playlistStatistics: "סטטיסטיקות פלייליסטים",
	playlistsWithAds: "פלייליסטים עם פרסומות",
	playlistsWithoutAds: "פלייליסטים ללא פרסומות",
	podcast: "פודקאסט",
	podcastStreams: "זרמי פודקאסט",
	podcasts: "פודקאסטים",
	ports: "יציאות",
	position: "עמדה",
	positionReviewDate: "תאריך סקירת משרה",
	preDefinedFilters: "מסננים מוגדרים מראש",
	preview: "תצוגה מקדימה",
	previous: "קודם",
	previousStep: "שלב קודם",
	price: "מחיר",
	priceB2b: "מחיר תאגידי",
	priceBasic: "מחיר בסיסי",
	priceGroup1: "קבוצת מחיר 1",
	priceGroup2: "קבוצת מחיר 2",
	priceGroup3: "קבוצת מחיר 3",
	priceLists: "רשימות מחירים",
	printedCount: "מספר הדפסות",
	printer: "מדפסת",
	printers: "מדפסות",
	priority: "עדיפות",
	priorityDescription: "חוקי תכנון זמן",
	private: "פרטי",
	privateChat: "צ'אט פרטי",
	privateChatDescription: "רק משתמשים שנבחרו יכולים לראות ולהצטרף לצ'אט זה",
	problem: "בעיה",
	problemDescription: "תיאור הבעיה",
	problemGroup: "קבוצת בעיות",
	problemGroupSupervisorsPlaceholder: "משתמשים האחראים לטיפול בכרטיסים בקבוצת הבעיות הזו",
	problemGroupSupervisorsTab: "מפקחים",
	processTime: "זמן תהליך",
	processing: "מעבד",
	progress: "התקדמות",
	product: "מוצר",
	productCare: "טיפוח מוצר",
	products: "מוצרים",
	productsLinked: "מוצרים מקושרים",
	project: "פרויקט",
	projectChanges: "שינויים בפרויקט",
	projectDeadline: "מועד סיום פרויקט",
	projectDetails: "פרטי פרויקט",
	projectEndDate: "תאריך סיום הפרויקט",
	projectID: "מזהה פרויקט",
	projectPartition: "חלק מפרויקט",
	projectPrice: "מחיר הפרויקט",
	projectPrice2: "מחיר פרויקט",
	projectStartDate: "תאריך תחילת הפרויקט",
	projectType: "סוג פרויקט",
	projectTypes: "סוגי פרויקטים",
	projects: "פרויקטים",
	promoCode: "קוד קידום מכירות",
	promoCodes: "קודי קידום",
	promoCodesAndCertificates: "קודי קידום ותעודות",
	promotions: "מבצעים",
	propertyNumber: "מספר נכס",
	providing: "מתן",
	punchActivity: "פעילות נוכחות",
	pto: "חופשה בתשלום",
	partial: "חלקי",
	quantity: "כמות",
	radioDashboard: "לוח בקרת רדיו",
	radioManagementOverview: "סקירת ניהול שידורי רדיו",
	radioStatistics: "סטטיסטיקות רדיו",
	raises: "תוספות",
	ram: "זיכרון",
	rate: "שיעור",
	rating: "דירוג",
	readOnly: "קריאה בלבד",
	readOnlyChatNotice: "הצ'אט הזה הוא לקריאה בלבד עבור משתתפים. רק מנהלים יכולים לכתוב הודעות.",
	readyToGetStarted: "מוכן להתחיל",
	recalculatePayroll: "חשב מחדש תלוש שכר",
	recentClients: "לקוחות אחרונים",
	recentContent: "תוכן אחרון",
	recentMessages: "הודעות אחרונות",
	recentOrders: "הזמנות אחרונות",
	recentTickets: "כרטיסים אחרונים",
	recentTracks: "שירים אחרונים",
	refresh: "רענן",
	registeredAddress: "כתובת רשומה",
	regularHours: "שעות רגילות",
	regularHoursHrScheduleHint:
		"מילוי אוטומטי מהגדרות משאבי אנוש: ימי עבודה בתקופה × שעות ליום. ניתן לעריכה.",
	regularPlaylists: "פלייליסטים רגילים",
	relatedList: "רשימה קשורה",
	relatedObjects: "אובייקטים קשורים",
	relatedProducts: "מוצרים קשורים",
	relatedTasks: "משימות קשורות",
	relations: "יחסים",
	remainingVacation: "חופשה שנותרה",
	remote: "מרחוק",
	remoteWorkDays: "ימי עבודה מרחוק",
	remove: "הסר",
	removeFromList: "הסר מהרשימה",
	removeItem: "הסר פריט",
	removed: "הוסרה",
	reopen: "פתח שוב",
	replaceableProduct: "מוצר מחליף",
	replaceableProducts: "מוצרים שניתנים להחלפה",
	replied: "נענה",
	reply: "להגיב",
	request: "בקשה",
	requestedForUser: "מבוקש עבור",
	reset: "איפוס",
	responseTimeDistribution: "התפלגות זמן תגובה",
	responsible: "אחראי",
	responsibleAndUsers: "אחראים ומשתמשים",
	restoreSelected: "שוחזר קבצים נבחרים",
	restored: "שוחזר",
	returning: "חוזר",
	revenue: "הכנסות",
	revenueOverview: "סקירת הכנסות",
	review: "مراجعה",
	rightNow: "עכשיו",
	role: "תפקיד",
	rom: "זיכרון לקריאה בלבד",
	room: "חדר",
	routers: "ראוטרים",
	rpaPrice: "מחיר עבודת מחלקת RPA",
	ruleName: "שם חוק",
	salary: "שכר",
	salaryReviewDate: "תאריך סקירת שכר",
	sale: "מכירה",
	salePrice: "מחיר מכירה",
	salesBreakdownByCategory: "פירוט מכירות לפי קטגוריה",
	salesPerformanceOverTime: "ביצועי מכירות לאורך זמן",
	sat: "שבת",
	save: "שמור",
	saveChanges: "שמור שינויים",
	saveComment: "שמור הערה",
	saved: "נשמר",
	schedulingDisabled: "תכנון מושבת",
	schedulingEnabled: "תכנון מופעל",
	schedulingRules: "חוקי תכנון זמן",
	search: "חפש",
	searchByNameOrId: "חפש לפי שם או מזהה…",
	searchChat: "חפש צ'אט...",
	searchChatGroups: "חפש בקבוצות צ'אט...",
	searchConversations: "חיפוש משוחחות...",
	searchResults: "תוצאות חיפוש",
	searchUsers: "חפש משתמשים...",
	secondary: "משני",
	seconds: "שניות",
	securityAcknowledge: "אישור קבלה",
	securityActions: "פעולות",
	securityActiveBadge: "פעיל",
	securityActiveSessions: "פגישות פעילות",
	securityActivityStatClicks: "לחיצות",
	securityActivityStatKeys: "מקשים",
	securityActivityStatMoves: "תנועות",
	securityActivityTimeline: "ציר זמן פעילות",
	securityAdminNotes: "הערות מנהל",
	securityAdminNotesDevice: "הערות פנימיות על מכשיר זה...",
	securityAgentHeartbeat: "דופק סוכן",
	securityAlertClipPlural: "קטעי התראה בעמוד זה",
	securityAlertClipSingular: "קטע מהתראה בעמוד זה",
	securityAlertCount: "התראה",
	securityAlertCountPlural: "התראות",
	securityAlertDrawerNoMedia:
		"אין מדיה מקושרת. נדרש FFmpeg לסוכן. ב-Windows PATH או FFMPEG_PATH. בדוק יומן.",
	securityAlertDrawerVideoFailed:
		"נשלחה פקודת וידאו אך לא הועלה קובץ. ייתכן שגיאה בסוכן — בדוק יומן במכשיר.",
	securityAlertDrawerVideoPending: "הווידאו מוקלט ויופיע בקרוב. הסוכן מצלם ומעלה כעת.",
	securityAlertRecordings: "הקלטות התראה",
	securityAlertRecordingsOnly: "רק הקלטות התראה",
	securityAlertSt_acknowledged: "אושר",
	securityAlertSt_false_positive: "חיובי שגוי",
	securityAlertSt_open: "פתוח",
	securityAlertSt_resolved: "נפתר",
	securityAlertsTitle: "התראות אבטחה",
	securityAllDevices: "כל המכשירים",
	securityAllEventTypes: "כל הסוגים",
	securityAllRules: "כל הכללים",
	securityAllSeverities: "כל רמות החומרה",
	securityAllStatuses: "כל הסטטוסים",
	securityAppProcessTracking: "מעקב אפליקציה/תהליך",
	securityAppTracking: "מעקב אפליקציות",
	securityAppUsageToday: "שימוש באפליקציות היום (דקות)",
	securityAssignedUser: "משתמש מוקצה",
	securityBadgeAlertText: "התראה",
	securityBadgeApp: "אפליקציה",
	securityBadgeApps: "אפליקציות",
	securityBadgeCapture: "לכידה",
	securityBadgeFiles: "קבצים",
	securityBadgeOff: "כבוי",
	securityBadgeScr: "מסך",
	securityBadgeScreenshot: "צילום מסך",
	securityBadgeVideo: "וידאו",
	securityBadgeWeb: "אינטרנט",
	securityCapture: "לכידה",
	securityCaptureEnabledMaster: "לכידה מופעלת (ראשי)",
	securityCaptureEverySeconds: "צילום כל (שניות)",
	securityCaptureMasterSwitch: "לכידה מופעלת (מתג ראשי)",
	securityCaptureModes: "מצבי לכידה",
	securityCaptureOffAlertBody:
		"לכידה מושבתת במפורש ברמת המכשיר, דורסת מדיניות. התראות נשלחות אך ללא צילום או וידאו.",
	securityCaptureOffAlertTitle: "עקיפת לכידה: כבוי",
	securityCaptureRecorded: "הלכידה נרשמה",
	securityCaptureWhenOnDesc: "כשמופעל אפשר צילום ווידאו; כיבוי משבית את שניהם",
	securityChartMinutes: "דקות",
	securityChartVisits: "ביקורים",
	securityClearFilters: "נקה מסננים",
	securityClickLeft: "ש",
	securityClickMiddle: "א",
	securityClickPlain: "לחיצה",
	securityClickRight: "י",
	securityClipWord: "קטע",
	securityConnectedDevices: "מכשירים מחוברים",
	securityCreated: "נוצר",
	securityDeleteDevice: "מחק מכשיר",
	securityDeleteDeviceConfirm: "האם אתה בטוח שברצונך למחוק",
	securityDeleteDeviceNote: "פעולה זו מסירה רק את רשומת מכשיר האבטחה. פרופיל המחשב ב-IT לא יושפע.",
	securityDeleteDeviceTitle: "מחק מכשיר אבטחה",
	securityDeleteMedia: "מחק",
	securityDeletePolicyConfirm: "למחוק מדיניות זו?",
	securityDevice: "מכשיר",
	securityDeviceFallback: "מכשיר",
	securityDeviceIdLabel: "מזהה מכשיר",
	securityDeviceNotFound: "המכשיר לא נמצא",
	securityDeviceSettings: "הגדרות מכשיר",
	securityDeviceSettingsHint: "דורס את המדיניות הפעילה למכשיר זה. אם ריק — יורש מהמדיניות.",
	securityDevicesBreadcrumb: "מכשירים",
	securityDevicesTitle: "מכשירי אבטחה",
	securityDevicesWithAlerts: "מכשירים עם התראות",
	securityDividerCapture: "לכידה",
	securityDividerNotes: "הערות",
	securityDividerTracking: "מעקב",
	securityDuration: "משך",
	securityEg15: "למשל 15",
	securityEg30: "למשל 30",
	securityEg300: "למשל 300",
	securityEg5: "למשל 5",
	securityEg60: "למשל 60",
	securityEnabled: "מופעל",
	securityEnd: "סוף",
	securityEventFlushSeconds: "ריקון אירועים (שניות)",
	securityEventsCount: "אירוע",
	securityEventsCountPlural: "אירועים",
	securityEvtAppProcess: "אפליקציה / תהליך",
	securityEvtAppUsage: "שימוש באפליקציה",
	securityEvtFileEvent: "אירוע קובץ",
	securityEvtHeartbeat: "דופק",
	securityEvtInputActivity: "פעילות קלט",
	securityEvtKeystroke: "לחיצת מקש",
	securityEvtMouseClick: "לחיצת עכבר",
	securityEvtSessionEnd: "סוף פגישה",
	securityEvtSessionStart: "תחילת פגישה",
	securityEvtSystemBoot: "אתחול מערכת",
	securityEvtSystemShutdown: "כיבוי מערכת",
	securityEvtUsb: "אירוע USB",
	securityEvtUserLogin: "כניסת משתמש",
	securityEvtUserLogout: "יציאת משתמש",
	securityEvtWebVisit: "ביקור באתר",
	securityEvtWorkstationLock: "המסך ננעל",
	securityEvtWorkstationUnlock: "המסך שוחרר",
	securityFailedLoadOverview: "טעינת סקירת האבטחה נכשלה",
	securityFailedSavePolicy: "שמירת המדיניות נכשלה",
	securityFalsePositiveBtn: "חיובי שגוי",
	securityFileEventTracking: "מעקב אירועי קבצים",
	securityFilterByDate: "סינון לפי תאריך",
	securityFilterDateRange: "סינון לפי טווח תאריכים",
	securityFilteredSuffix: "(מסונן)",
	securityFps: "FPS",
	securityHostname: "שם מארח",
	securityInputActivityCounts: "פעילות קלט (ספירה)",
	securityInputKeystrokeClickTracking: "מעקב מקשים/לחיצות",
	securityInputModeActivityCountsShort: "פעילות בלבד — ספירת מקשים/לחיצות",
	securityInputModeActivityOnly: "פעילות בלבד (ספירה)",
	securityInputModeDisabled: "מושבת",
	securityInputModeDisabledShort: "מושבת — ללא מדדי קלט",
	securityInputModeEventsOnly: "אירועים בלבד",
	securityInputModeEventsStream: "אירועים בלבד — זרם גולמי",
	securityInputModeFullDetail: "פירוט מלא (מקשים + לחיצות)",
	securityInputModeFullKeystrokes: "פירוט מלא — מקשים + מיקומי לחיצה",
	securityInputModeShort: "מצב קלט",
	securityInputTrackingMode: "מצב מעקב קלט",
	securityInternalNotesPlaceholder: "הערות פנימיות...",
	securityKeyCharPrefix: "מקש:",
	securityLastSeen: "נראה לאחרונה",
	securityLatestClip: "קטע אחרון",
	securityLinkedItPc: "מחשב IT מקושר:",
	securityLiveLoadingSub: "מתחבר לסוכן — תצוגה מקדימה של המסך תופיע בעוד רגע.",
	securityLiveOfflineHint: "המכשיר לא מקוון — תצוגה חיה דורשת סוכן מחובר.",
	securityLivePressStart: "לחץ על התחל שידור חי לפתיחת הזרם.",
	securityLiveScreenAlt: "מסך חי",
	securityLiveStatusLive: "חי",
	securityLiveStatusStandby: "מוכן",
	securityLiveStreamHint: "שידור בחצי רזולוציה, עד 10 פריימים/שנ׳. סוכן v1.4.0+ עם jimp.",
	securityLiveWaitingFrames: "טוען שידור חי…",
	securityLoggedInSince: "מחובר מאז",
	securityLoggedOutSince: "התנתקות אחרונה",
	securityMediaPrefix: "מדיה",
	securityMediaTitle: "מדיה לאבטחה",
	securityMiddleClick: "לחיצת גלגלת",
	securityModuleErrorTitle: "שגיאת מודול אבטחה",
	securityName: "שם",
	securityNearbyScreenshots: "צילומי מסך קרובים",
	securityNever: "אף פעם",
	securityNewMediaBadge: "חדש",
	securityNewPolicy: "מדיניות חדשה",
	securityNoActivityEvents: "אין אירועי פעילות",
	securityNoAlertRecordingsPage: "אין הקלטות התראה בעמוד זה",
	securityNoAlertsForDevice: "אין התראות למכשיר זה",
	securityNoAlertsFound: "לא נמצאו התראות",
	securityNoDevicesFound: "לא נמצאו מכשירים",
	securityNoEventsMatchFilter: "אין אירועים התואמים למסנן",
	securityNoOpenAlerts: "אין התראות פתוחות",
	securityNoPoliciesConfigured: "לא הוגדרו מדיניות. צור אחת כדי להתחיל ניטור.",
	securityNoPreview: "אין תצוגה מקדימה",
	securityNoRiskyDevices: "אין מכשירים בסיכון",
	securityNoScreenshotsFound: "לא נמצאו צילומי מסך",
	securityNoScreenshotsYet: "עדיין אין צילומי מסך",
	securityNoSessionsFound: "לא נמצאו פגישות",
	securityNoSessionsRecorded: "לא נרשמו פגישות",
	securityNoUserSession: "אין סשן פעיל",
	securityNoUserSessionLiveHint:
		"המחשב דלוק אך אין משתמש מחובר. תצוגה חיה וצילומי מסך אינם זמינים.",
	securityNoUserSessionTitle: "אף משתמש לא מחובר",
	securityNoVideoSegmentsFound: "לא נמצאו מקטעי וידאו",
	securityNoVideosYet: "עדיין אין מקטעי וידאו",
	securityOS: "מערכת",
	securityOnlineDevices: "מכשירים מקוונים",
	securityOpenAlerts: "התראות פתוחות",
	securityOpenPcRecord: "פתח רשומת מחשב",
	securityOverrideOff: "כבוי",
	securityOverrideOn: "פועל",
	securityOverridePrefix: "עקיפה:",
	securityOverviewTitle: "סקירת אבטחה",
	securityPageOf: "עמוד",
	securityPolActivityTrackingDivider: "מעקב פעילות",
	securityPolAfterHoursStart: "תחילת שעות לא עבודה",
	securityPolAlertClipLength: "אורך קטע וידאו להתראה (שניות)",
	securityPolAlertScore: "ציון התראה (0–100)",
	securityPolAlertSeverity: "חומרת התראה",
	securityPolAlertVideoDivider: "הקלטת וידאו להתראה",
	securityPolAlertVideoInfo:
		"כשכלל מופעל, הסוכן מקליט קטע שולחן עבודה אחד לפי ההגדרות. אורך ואיכות זהים לכל הכללים.",
	securityPolAllowedHoursDivider: "שעות לכידה מותרות",
	securityPolBadgeAlert: "התראה",
	securityPolBlockedApps: "אפליקציות חסומות",
	securityPolBlockedAppsPh: "למשל telegram, discord, torrent",
	securityPolBlockedDomains: "דומיינים חסומים",
	securityPolBlockedDomainsPh: "למשל torrent-site.com, telegram.org",
	securityPolBreadcrumbPolicies: "מדיניות",
	securityPolBulkThreshold: "סף אירועי קבצים המוניים (אירועים/אצווה)",
	securityPolBulkThresholdDesc: "מספר אירועי קבצים הרסניים באצווה אחת להפעלת הכלל",
	securityPolCollectInputMetrics: "איסוף מדדי פעילות קלט",
	securityPolCollectInputMetricsDesc: "ספירת אירועי עכבר/מקלדת בלבד (ללא תוכן מקשים)",
	securityPolCreateAlert: "צור התראה",
	securityPolCreateAlertDesc: "בהתאמת הכלל נפתחת התראת אבטחה (ווידאו לפי לשונית לכידה)",
	securityPolDescription: "תיאור",
	securityPolEditPolicy: "עריכת מדיניות",
	securityPolEnableRule: "הפעל כלל",
	securityPolEventsRetention: "שמירת אירועים (ימים)",
	securityPolEventsRetentionDesc: "רשומות פעילות ישנות יותר יימחקו",
	securityPolExcludedDomains: "דומיינים מוחרגים",
	securityPolExcludedDomainsPh: "למשל online-banking.com",
	securityPolExcludedProcesses: "שמות תהליכים מוחרגים",
	securityPolExcludedProcessesPh: "למשל 1Password, Bitwarden",
	securityPolInputActivityCounts: "פעילות בלבד — ספירת עכבר/מקשים",
	securityPolInputDisabledNoTrack: "מושבת — ללא מעקב קלט",
	securityPolInputEventsCount: "אירועים בלבד — ספירת מקשים בלבד",
	securityPolInputFullDetail: "פירוט מלא — מקשים + מיקומי לחיצה",
	securityPolInputModeLabel: "מצב מעקב קלט",
	securityPolInputTrackingDivider: "מעקב קלט",
	securityPolMaskSensitive: "הסתר חלונות רגישים (מנהלי סיסמאות, בנקאות)",
	securityPolMaskSensitiveDesc: "ללא צילום מסך לאפליקציות/חלונות מוחרגים",
	securityPolMaxFps: "FPS מקסימלי",
	securityPolMediaRetention: "שמירת מדיה (ימים)",
	securityPolMediaRetentionDesc: "צילומי מסך ווידאו ישנים יותר יימחקו",
	securityPolNewSecurityPolicy: "מדיניות אבטחה חדשה",
	securityPolNotifyUsersDesc:
		"המשתמשים שנבחרו יקבלו התראה בתוך האפליקציה כשכל כלל במדיניות זו יופעל.",
	securityPolNotifyUsersLabel: "הודע למנהלים בעת הפעלת מדיניות",
	securityPolNotifyUsersPh: "חפש ובחר משתמשים לקבלת הודעות…",
	securityPolPolicyName: "שם מדיניות",
	securityPolPolicyNamePh: "למשל מדיניות צוות פיתוח",
	securityPolPriority: "עדיפות",
	securityPolPriorityDesc: "מספר גבוה = נבחן ראשון",
	securityPolRecordVideoOnAlert: "הקלט וידאו בהתראת אבטחה",
	securityPolRecordVideoOnAlertDesc: "כבוי: התראות נוצרות בלי וידאו",
	securityPolRuleAfterHoursDesc: "מופעל כשמזוהה פעילות מחוץ לשעות העבודה שהוגדרו.",
	securityPolRuleAfterHoursLabel: "פעילות מחוץ לשעות עבודה",
	securityPolRuleBlockedAppDesc: "מופעל כשמשתמש מנוטר פותח אפליקציה מהרשימה החסומה.",
	securityPolRuleBlockedAppLabel: "אפליקציה חסומה",
	securityPolRuleBlockedDomainDesc: "מופעל כשמשתמש מנוטר מבקר בדומיין מהרשימה החסומה.",
	securityPolRuleBlockedDomainLabel: "דומיין חסום",
	securityPolRuleBulkFileDesc: "מופעל כשמתרחשות מחיקות/שינויי שם/העברות רבות של קבצים באצווה אחת.",
	securityPolRuleBulkFileLabel: "פעולות קבצים המוניות",
	securityPolRuleUsbDesc: "מופעל כשמחברים USB למכשיר מנוטר.",
	securityPolRuleUsbLabel: "זוהה אחסון USB",
	securityPolRulesIntro:
		"הכללים מגדירים הפרה וציון התראה. עם «צור התראה» נוצרת התראת אבטחה; הווידאו לפי לשונית הלכידה לכל הכללים.",
	securityPolSavePolicy: "שמור מדיניות",
	securityPolScope: "היקף",
	securityPolScopeDepartment: "מחלקה",
	securityPolScopeDevice: "מכשירים ספציפיים",
	securityPolScopeGlobal: "גלובלי — חל על כל המכשירים",
	securityPolScopeUser: "משתמשים ספציפיים",
	securityPolTabCapture: "לכידה",
	securityPolTabPrivacy: "פרטיות וחריגים",
	securityPolTabRetention: "שמירה",
	securityPolTabRules: "כללים",
	securityPolTrackApps: "מעקב אפליקציות פעילות",
	securityPolTrackFiles: "מעקב פעילות קבצים",
	securityPolTrackWebsites: "מעקב ביקורי אתרים",
	securityPolTrackingMaster: "מעקב מופעל (מתג ראשי)",
	securityPolTrackingMasterDesc: "כבוי: מעקב אפליקציה, אתר, קבצים וקלט לא פעיל",
	securityPolVisibleNotice: "הצג הודעת ניטור גלויה לעובדים",
	securityPolVisibleNoticeDesc: "מציג באנר המודיע שהניטור פעיל",
	securityPolWorkDayStart: "תחילת יום עבודה (סוף שעות לא עבודה)",
	securityPolWorkingHours: "שעות עבודה (אופציונלי)",
	securityPolWorkingHoursDesc: "לכידה רק בחלון זה. פורמט: שעה:דקה-שעה:דקה. ריק = תמיד.",
	securityPolWorkingHoursPh: "09:00-18:00",
	securityPoliciesCaptureHint:
		"התגים מציגים מה מופעל. כדי להפעיל או לכבות צילומי מסך, וידאו, אפליקציות, רשת או קבצים — פתחו מדיניות (סמל העיפרון) → לשונית לכידה.",
	securityPoliciesTitle: "מדיניות אבטחה",
	securityPolicyDefaultBadge: "ברירת מחדל מדיניות",
	securityPriority: "עדיפות",
	securityQueued: "בתור!",
	securityRecentOpenAlerts: "התראות פתוחות אחרונות",
	securityRecentScreenshots: "צילומי מסך אחרונים",
	securityRecordEverySeconds: "הקלטה כל (שניות)",
	securityRecordVideo30s: "הקלטת וידאו (30 ש׳׳)",
	securityRefresh: "רענן",
	securityResolution: "רזולוציה",
	securityResolutionNotePlaceholder: "הערת פתרון (אופציונלי)",
	securityResolve: "לפתור",
	securityRightClick: "לחיצה ימנית",
	securityRule: "כלל",
	securityRuleCode_AFTER_HOURS: "מחוץ לשעות עבודה",
	securityRuleCode_BLOCKED_APP: "אפליקציה חסומה",
	securityRuleCode_BLOCKED_DOMAIN: "דומיין חסום",
	securityRuleCode_BULK_FILE_EVENTS: "אירועי קבצים המוניים",
	securityRuleCode_USB_DETECTED: "זוהה USB",
	securitySaveSettings: "שמור הגדרות",
	securitySaved: "נשמר",
	securityScope: "היקף",
	securityScopeType_department: "מחלקה",
	securityScopeType_device: "מכשיר",
	securityScopeType_global: "גלובלי",
	securityScopeType_user: "משתמש",
	securityScreenshotAlt: "צילום מסך",
	securityScreenshotOptionsBlank: "אפשרויות צילום (ריק = ברירת מחדל של מדיניות)",
	securityScreenshots: "צילומי מסך",
	securityScreenshotsCount: "צילומי מסך",
	securityScreenshotsLabel: "צילומי מסך",
	securityScreenshotsToday: "צילומי מסך היום",
	securitySearch: "חיפוש",
	securitySearchDevicesPlaceholder: "חיפוש שרת, מזהה מכשיר, משתמש...",
	securitySegmentLengthSeconds: "אורך מקטע (שניות)",
	securitySelectedCount: "נבחרו",
	securitySessionActive: "פעיל",
	securitySessionIdle: "סרק",
	securitySessionLocked: "המסך נעול",
	securitySessionLockedCaptureHint: "המסך נעול — צילומי מסך ותצוגה חיה אינם זמינים.",
	securitySessionLockedLiveHint:
		"המשתמש נעל את המסך. תצוגה חיה, צילומי מסך והקלטות מושבתים בזמן שהמסך נעול.",
	securitySessionLockedSince: "נעול מאז",
	securitySessionLockedTitle: "המסך נעול",
	securitySessionNotFound: "הפגישה לא נמצאה",
	securitySessionTimeline: "ציר זמן של הפגישה",
	securitySessionWord: "פגישה",
	securitySessionsTitle: "פגישות",
	securitySettingsDrawerTitle: "הגדרות",
	securitySettingsOverrideHint: "דורסים את המדיניות רק למכשיר זה. השאר כדי ליירש.",
	securitySev_critical: "קריטי",
	securitySev_high: "גבוה",
	securitySev_low: "נמוך",
	securitySev_medium: "בינוני",
	securitySeverity: "חומרה",
	securityShowAllVideos: "הצג את כל הסרטונים",
	securitySourceEvents: "אירועי מקור",
	securitySpeedSec: "מהירות (שנ׳):",
	securityStart: "התחלה",
	securityStartLive: "התחל שידור חי",
	securityStatOf: "מתוך",
	securityStatus: "סטטוס",
	securityStatus_error: "שגיאה",
	securityStatus_offline: "לא מקוון",
	securityStatus_online: "מקוון",
	securityStatus_pending: "ממתין",
	securityStatus_unknown: "לא ידוע",
	securityStopLive: "עצור שידור חי",
	securityTabActivity: "פעילות",
	securityTabAlerts: "התראות",
	securityTabLive: "חי",
	securityTabScreenshots: "צילומי מסך",
	securityTabSessions: "פגישות",
	securityTabSettings: "הגדרות",
	securityTabVideos: "סרטונים",
	securityTakeScreenshot: "צילום מסך",
	securityTitle: "כותרת",
	securityTooltipAppTrack: "מעקב אפליקציות",
	securityTooltipCaptureMaster: "הפעלה/כיבוי צילום מסך ומדיה (ראשי)",
	securityTooltipScreenshot: "הפעלת צילום מסך",
	securityTooltipTrackingMaster: "מתג ראשי למעקב אפליקציות, אתר, קבצים וקלט",
	securityTooltipWebTrack: "מעקב דומיינים",
	securityTopRiskyDevices: "מכשירים בסיכון הגבוה ביותר",
	securityTracking: "מעקב",
	securityTrackingEnabledMaster: "מעקב מופעל (ראשי)",
	securityTrackingMasterSwitch: "מעקב מופעל (ראשי)",
	securityTrackingOffAlertBody: "מעקב פעילות מושבת במכשיר, דורס מדיניות.",
	securityTrackingOffAlertTitle: "עקיפת מעקב: כבוי",
	securityTrackingWhenOffDesc: "כשכבוי מעקב אפליקציה, אתר, קבצים וקלט לא פעיל",
	securityUnassigned: "לא משויך",
	securityUnknown: "לא ידוע",
	securityUnknownDevice: "מכשיר לא ידוע",
	securityUsePolicyDefault: "ברירת מחדל מדיניות",
	securityUser: "משתמש",
	securityUserLoggedIn: "מחובר",
	securityVideoOffAlertBody:
		"הקלטת וידאו מושבתת במכשיר. לא יוקלטו סרטוני התראה גם אם המדיניות מאפשרת.",
	securityVideoOffAlertTitle: "עקיפת וידאו: כבוי",
	securityVideoOptionsBlank: "אפשרויות וידאו (ריק = מדיניות)",
	securityVideoPlayAllHint: "נגן הכל מהקטע הנבחר לכיוון ישנים יותר; בסוף העמוד נטען הבא.",
	securityVideoRecording: "הקלטת וידאו",
	securityVideoSegments: "מקטעי וידאו",
	securityVideoSegmentsCount: "מקטעי וידאו",
	securityViewDetail: "פרטים",
	securityWebDomainTracking: "מעקב דומיינים",
	securityWebPollSeconds: "סקר היסטוריית אתר (שניות)",
	securityWebTracking: "מעקב אינטרנט",
	securityWebsiteVisitsToday: "ביקורי אתרים היום",
	securityWhen: "מתי",
	selectAlbum: "בחר אלבום",
	selectAll: "בחר הכול",
	selectArtist: "בחר זמרן",
	selectBoard: "לוח נבחר",
	selectCategory: "בחר קטגוריה",
	selectChatPartner: "בחר שותף לצ'אט",
	selectClosedDate: "בחר תאריך סגירה",
	selectDate: "בחר תאריך",
	selectDays: "בחר ימים",
	selectDomain: "בחר תחום",
	selectEmployee: "בחר עובד",
	selectFiles: "בחר קבצים",
	selectGroup: "בחר קבוצה",
	selectOpenedDate: "בחר תאריך פתיחה",
	selectParentDepartment: "בחר מחלקה הורה",
	selectParentUser: "בחר משתמש הורה",
	selectPeriod: "בחר תקופה",
	selectPlatformToManageAndNavigate: "בחר פלטפורמה כדי לנהל ולנווט",
	selectPlaylist: "בחר רשימת נגינה",
	selectProduct: "בחר מוצר",
	selectSomething: "בחר משהו",
	selectUsers: "בחר משתמשים",
	selectedSteps: "שלבים שנבחרו",
	selectedUsers: "משתמשים נבחרים",
	seleteSelected: "בחר קבצים נבחרים",
	send: "שלח",
	sent: "נשלח",
	seoDesc: "תיאור SEO",
	servicesAndPrices: "שירותים ומחירים",
	setCostOfBuildingPermit: "הגדר עלות של רשיון בנייה",
	setDayOff: "הגדרת יום חופש",
	settings: "הגדרות",
	shiftSchedule: "לוח משמרות",
	showAllSteps: "הצג את כל השלבים",
	showHistory: "הצג היסטוריה",
	showProjectDetails: "הצג פרטי פרויקט",
	showTableColumnFilters: "הצגת מסנני עמודות",
	showTimeline: "הצג ציר זמן",
	showing: "מוצג",
	shuffle: "ערבב",
	shuffleEnabled: "ערבוב מופעל",
	shuffleOverride: "חוקי תכנון",
	shuffleOverrideDesc: "חוקי תכנון",
	shuffleOverrideValue: "חוקי תכנון",
	sickLeave: "חופשת מחלה",
	sickLeaveDays: "ימי מחלה",
	signIn: "התחבר",
	signUp: "הרשם",
	size: "גודל",
	slider: "סליידר",
	small: "קטן",
	smb: "תיקיית השרת",
	socialAmount: "סכום תשלום סוציאלי",
	socialCardImages: "תמונות כרטיס חברתי",
	socialCart: "כרטיס חברתי",
	socialNetworkLink: "קישור לרשת החברתית",
	socialRate: "שיעור תשלום סוציאלי",
	software: "תוכנה",
	softwareSkills: "כישורי תוכנה",
	somethingWentWrong: "משהו השתבש",
	somethingWentWrongInCreatingSteps: "משהו השתבש ביצירת השלבים! אנא נסה שוב",
	sortBy: "מיין על פי",
	source: "מקור",
	special: "מיוחד",
	specialItems: "פריטים מיוחדים",
	speed: "מהירות",
	starred: "מוסתר",
	starredMessages: "הודעות מסומנות בכוכב",
	start: "התחל",
	startCall: "התחל שיחה",
	startDate: "תאריך התחלה",
	startDateShort: "תאריך התחלה",
	startRecording: "התחל את ההקלטה",
	startTime: "זמן התחלה",
	startVideoCall: "התחל שיחת וידאו",
	starts: "מתחיל",
	state: "מדינה",
	states: "מדינות",
	status: "סטטוס",
	visibility: "נראות",
	statusUpdate: "עדכון סטטוס",
	stayAnonymous: "שמור על אנונימיות",
	step: "שלב",
	stepIsNotStartedYet: "השלב עדיין לא התחיל",
	stepStatus: "מצב שלב",
	stepStatusChangedByUser: "מצב השלב שונה על ידי המשתמש",
	steps: "שלבים",
	stepsLeft: "שלבים נשארים",
	stillInOffice: "עדיין במשרד",
	stockAndProductOverview: "סקירת מלאי ומוצרים",
	stop: "עצור",
	stopRecording: "עצור את ההקלטה",
	stopped: "עצר",
	streamDJ: "DJ רדיו",
	streamStatistics: "סטטיסטיקות זרמים",
	streaming: "זרימה",
	streamsWithShuffle: "זרמים עם ערבוב",
	street: "רחוב",
	subDesc: "תת תיאור",
	submit: "שלח",
	submittedProjects: "פרויקטים שהוגשו",
	subscription: "מינוי",
	subscriptions: "מנויים",
	substation: "תחנת משנה",
	substationNumber: "מספר תחנת משנה",
	subtasks: "משימות משנה",
	subtasksPlaceholder: "הכנס כל משימה משנה בשורה חדשה",
	subtitle: "כותרת משנה",
	success: "הצלחה",
	suffix: "סוניק",
	sun: "יום ראשון",
	support: "תמיכה",
	supportText: "לכל השאלות כתוב",
	switch: "מתג",
	switchers: "מתגים",
	switches: "מדפסות",
	syncedFromGoogleContacts: "מסונכרן מאנשי הקשר של Google",
	systemSettings: "הגדרות מערכת",
	table: "טבלה",
	tag: "תג",
	tags: "תגים",
	takeMeHome: "קח אותי הביתה",
	taskCreatedSuccessfully: "משימה נוצרה בהצלחה",
	taskCreatedSuccessfullyDescription: "משימה נוצרה בהצלחה",
	taskDescription: "תיאור משימה",
	taskMoved: "משימה עברה",
	taskMovedDescription: "משימה עברה לקטגוריה חדשה",
	taskStatusDistribution: "הפצת מצב המשימה",
	taskTitle: "כותרת משימה",
	tasksAssigned: "משימות שהוקצו",
	taxCode: "קוד מס",
	taxNote: "תווית",
	taxes: "מסים",
	technicalFilesUrl: "כתובת קבצים טכניים",
	telegram: "טלגרם",
	text: "טקסט",
	theConstructionDepPrice: "מחיר מחלקת הבנייה",
	theNumberOfAct: "מספר הפעולות",
	thePriceOfProject: "מחיר הפרויקט",
	themePickerLabel: "ערכת נושא",
	thereIsNoResponsible: "אין אחראי",
	thisMonth: "החודש",
	thu: "יום חמישי",
	ticket: "כרטיס",
	ticketClosed: "כרטיס נסגר",
	ticketCreateSaveDisabledHint:
		"בחרו דומיין, קבוצת בעיה (אם קיימת), בעיה, ומלאו שדות קשורים חובה לפני השמירה.",
	ticketDashboard: "לוח בקרת כרטיסים",
	ticketDomain: "תחום",
	ticketHierarchyAddProblem: "הוסף בעיה",
	ticketHierarchyAddProblemGroup: "הוסף קבוצת בעיות",
	ticketHierarchyAddRelatedList: "הוסף רשימה מקושרת",
	ticketHierarchyAddTicket: "הוסף קריאה",
	ticketHierarchyAddTicketDomain: "הוסף תחום",
	ticketHierarchyAddTicketHint: "ייפתח יצירת קריאה חדשה עם התחום הזה.",
	ticketHierarchyGroupsInDomain: "קבוצות בעיות בתחום זה",
	ticketHierarchyNoneYet: "אין עדיין — השתמש בכפתור למעלה.",
	ticketHierarchyProblemsInGroup: "בעיות בקבוצה זו",
	ticketHierarchyProblemsLinkedToList: "בעיות המשתמשות ברשימה זו",
	ticketSystemOverview: "סקירת ביצועים ומדדים של מערכת הכרטיסים",
	ticketTitle: "כותרת",
	ticketType: "סוג",
	ticketTypeDomainsHint:
		"השאר ריק כדי שהסוג יהיה זמין בכל הדומיינים. בחר דומיין אחד או יותר כדי להציג אותו רק שם.",
	ticketTypeDomainsListAll: "כל הדומיינים",
	ticketStatus_sent: "נשלח",
	ticketStatus_in_process: "בעיבוד",
	ticketStatus_resolved_rejected: "נדחה",
	ticketStatus_resolved_approved: "אושר",
	ticketStatus_moved_next: "הועבר לשלב הבא",
	ticketStatus_moved_prev: "הוחזר לשלב הקודם",
	ticketStatus_closed: "סגור",
	ticketStatus_not_accepted: "לא התקבל",
	ticketAction_start: "התחל טיפול",
	ticketAction_next: "שלב הבא",
	ticketAction_prev: "שלב קודם",
	ticketAction_approve: "אשר",
	ticketAction_reject: "דחה",
	ticketAction_close: "סגור כרטיס",
	ticketAction_cancel: "בטל כרטיס",
	ticketAction_comment: "הערה",
	cancelTicket: "בטל כרטיס",
	ticketCancelReason: "סיבת ביטול",
	ticketCancelComment: "הערה נוספת",
	ticketCancelCommentPlaceholder: "הוסף פרטים לפותח הכרטיס במידת הצורך",
	ticketCancelWarning:
		"הכרטיס יסומן כלא התקבל וייסגר. אם המשתמש עדיין צריך עזרה, עליו לפתוח כרטיס חדש.",
	ticketNotAccepted: "הכרטיס לא התקבל",
	ticketStepStatus_pending: "ממתין",
	ticketStepStatus_active: "פעיל",
	ticketStepStatus_completed: "הושלם",
	ticketStepStatus_approved: "אושר",
	ticketStepStatus_rejected: "נדחה",
	ticketStepStatus_closed: "סגור",
	ticketStepStatus_cancelled: "בוטל",
	tickets: "כרטיסים",
	ticketsByDepartment: "כרטיסים לפי מחלקה",
	ticketsByImportance: "כרטיסים לפי עדיפות",
	ticketsByProblem: "כרטיסים לפי סוג בעיה",
	ticketsByStatus: "כרטיסים לפי סטטוס",
	ticketsOverTime: "כרטיסים לאורך זמן",
	timAgreement: "הסכם TIM",
	timDelays: "עיכובי TIM",
	timSentProjects: "פרויקטים שנשלחו ל-TIM",
	time: "זמן",
	timeBasedScheduling: "תכנון בזמן",
	timeOff: "חופשה",
	timeRange: "טווח זמן",
	timeToClose: "זמן לסגירת כרטיס",
	timeToFirstResponse: "זמן לתגובה ראשונה",
	timeline: "ציר זמן",
	timestamp: "חותמת זמן",
	timezone: "אזור זמן",
	title: "כותרת",
	to: "אל",
	toChat: "לצ'אט",
	toDo: "לעשות",
	today: "היום",
	todaysSales: "מכירות היום",
	todo: "משימות",
	todoBoard: "לוח",
	todoBoards: "לוחות",
	todoCategories: "קטגוריות",
	todoCategory: "קטגוריה",
	todoLabel: "Label",
	todoLabels: "תגיות",
	todoTag: "תג",
	todoTags: "תגיות",
	todoTask: "משימה",
	todoTasks: "משימות",
	toggles: "מתגים",
	top: "מוביל",
	topCustomers: "לקוחות מובילים",
	topProducts: "מוצרים מובילים",
	total: "סך הכל",
	totalActiveTasks: "סך כל המשימות הפעילות",
	totalArtists: 'סה"כ אמנים',
	totalChats: "סה\"כ צ'אטים",
	totalClients: 'סה"כ לקוחות',
	totalCoins: 'סה"כ מטבעות',
	totalContent: 'סה"כ תוכן',
	totalCustomers: 'סה"כ לקוחות',
	totalDeductions: "סה״כ ניכויים",
	totalDuration: "משך זמן כולל",
	totalGroups: 'סה"כ קבוצות',
	totalHours: "סך שעות",
	missingDays: "ימים חסרים",
	missingHours: "שעות חסרות",
	scheduled: "מתוכנן",
	totalHoursWorked: "סך שעות עבודה",
	totalInTrash: "אשפה בכלל",
	totalMessages: 'סה"כ הודעות',
	totalOrders: 'סה"כ הזמנות',
	totalOvertime: "סך השעות הנוספות",
	totalPlaylists: 'סה"כ פלייליסטים',
	totalPrice: "מחיר כולל",
	totalProducts: 'סה"כ מוצרים',
	totalRevenue: 'סה"כ הכנסות',
	totalTickets: 'סה"כ כרטיסים',
	totalTracks: 'סה"כ שירים',
	totalUses: 'סה"כ שימושים',
	totalValue: "ערך כולל",
	track: "מסלול",
	trackPlaylist: "רשימת השמעה של שירים",
	tracks: "מסלולים",
	tracksByArtist: "שירים לפי אמן",
	transportAllowance: "מענק תחבורה",
	trash: "אשפה",
	trashAutoDeleteWarning: "אזהרת מחיקת אשפה אוטומטית",
	trashEmptied: "אשפה נקה",
	trashedOn: "נמחק ב",
	tryAgain: "נסה שוב",
	tue: "יום שלישי",
	type: "סוג",
	uncoveredInterval: "מרווח לא מכוסה",
	undefined: "לא מוגדר",
	undo: "בטל",
	university: "אוניברסיטה",
	universityDegree: "תואר אוניברסיטאי",
	universityDepartment: "מחלקת אוניברסיטה",
	unjustifiedAbsence: "היעדרות לא מוצדקת",
	unknown: "לא ידוע",
	unknownArtist: "אמן לא ידוע",
	unnamed: "ללא שם",
	unnamedClient: "לקוח ללא שם",
	unnamedTrack: "שיר ללא שם",
	unpaid: "ללא תשלום",
	unreadMessages: "הודעות שלא נקראו",
	unresolvedMissingIntervals: "מרווחים חסרים לא פתורים — השכר עלול להיות לא מדויק",
	upcomingBirthdays: "ימי הולדת קרובים",
	update: "עדכון",
	updatedAt: "עודכן ב",
	updates: "עדכונים",
	upload: "העלה",
	uploadDate: "תאריך העלאה",
	uploading: "מעלה",
	uploads: "העלאות",
	uptime: "זמן פעולה",
	urgent: "משנה",
	used: "נעשה שימוש",
	usedCount: "מספר השימושים",
	usedVacation: "חופשה שנוצלה",
	user: "משתמש",
	userArchive: "ארכיון משתמש",
	userDashboard: "לוח בקרת משתמש",
	userDeleted: "נמחק",
	userEntered: "המשתמש נכנס",
	userProfile: "פרופיל משתמש",
	userPayrollCalcUsesAttendance:
		"חישוב זה משתמש בסיכום הנוכחות והחופשות הקנוני עבור {monthKey}, ואז מחיל את כללי המס הפעילים מהגדרות משאבי אנוש.",
	userUpdated: "עודכן",
	userVisited: "המשתמש ביקר",
	username: "שם משתמש",
	users: "משאבי אנוש",
	vacationBalance: "יתרת חופשה",
	vacationDaysForPeriod: "ימי חופשה לתקופה הנבחרת",
	vacationInterval: "מרווח חופשה",
	vacationPay: "תשלום חופשה",
	value: "ערך",
	version: "גרסה",
	viber: "Viber",
	video: "וידאו",
	view: "צפה",
	viewAll: "צפייה בכל",
	viewDetails: "צפה בפרטים",
	viewMore: "הצג עוד",
	viewProject: "הצג פרויקט",
	viewSteps: "הצג שלבים",
	viewTrash: "צפייה באשפה",
	village: "כפר",
	villages: "רשימת נכסים",
	visitation: "ביקור",
	visitationDeadline: "מועד סיום ביקור",
	visitationDelays: "עיכובי ביקור",
	voltage: "מתח",
	voltageLevel: "רמת מתח",
	volumes: "נפחים",
	voluntaryPensionAmount: "סכום פנסיה התנדבותית",
	voluntaryPensionRate: "שיעור פנסיה התנדבותית (%)",
	vsPreviousPeriod: "לעומת התקופה הקודמת",
	warning: "אזהרה",
	warrantyDesc: "תיאור גירסה",
	warrantyEnd: "סוף גירסה",
	warrantyProvider: "ספק גירסה",
	warrantyStart: "התחלת גירסה",
	watchers: "מעקב",
	weatherAriaYerevanForecast: "תחזית מזג אוויר לירוואן",
	weatherCityYerevan: "ירוואן",
	weatherClear: "בהיר",
	weatherCloudy: "מעונן",
	weatherDrizzle: "טפטוף",
	weatherFog: "ערפל",
	weatherForecastUnavailable: "תחזית לא זמינה",
	weatherHeadingYerevan: "מזג אוויר בירוואן",
	weatherHumidity: "לחות",
	weatherLoadingShort: "מזג אוויר",
	weatherNextHours: "שעות הבאות",
	weatherPartlyCloudy: "מעונן חלקית",
	weatherRain: "גשם",
	weatherSnow: "שלג",
	weatherThunderstorm: "סופת רעמים",
	weatherUnknown: "תחזית",
	weatherWind: "רוח",
	weatherWindUnit: 'קמ"ש',
	wed: "יום רביעי",
	weekly: "שבועי",
	whatToDo: "מה לעשות",
	whatToDoLink: "מה לעשות",
	whatsapp: "WhatsApp",
	withAttachments: "עם קבצים מצורפים",
	withCoins: "עם מטבעות",
	withFavorites: "עם מועדפים",
	workDays: "ימי עבודה",
	workInformation: "מידע תעסוקתי",
	workTime: "שעות עבודה",
	workedDays: "ימי עבודה",
	workedHours: "שעות עבודה",
	working: "עובד",
	workingDays: "ימי עבודה",
	workingHoursByDay: "שעות עבודה לפי יום",
	workingMinutes: "דקות עבודה",
	workingState: "סטטוס עבודה",
	workingStatus: "סטטוס עבודה",
	write: "כתוב",
	writeUsIfThereAreAnyQuestions: "כתבו לנו אם יש שאלות",
	writingContent: "תוכן הכתיבה",
	writingNumber: "מספר כתיבה",
	yes: "כן",
	yesNextStep: "כן, עבור לשלב הבא",
	yesPreviousStep: "כן, עבור לשלב הקודם",
	youWontBeAbleToRevert: "לא תוכל לבטל את זה!",
	yourFileHasBeenDeleted: "הקובץ שלך נמחק.",
	yourFileHasBeenNotSaved: "הקובץ שלך לא נשמר.",
	yourFileHasBeenSaved: "הקובץ שלך נשמר.",
	zipCode: "מיקוד",
	zipCodes: "מיקוד",
	vacationIntervalNoDeduction: "חופשה אינה מנוכה בימים שאינם ימי עבודה",
	knowledgeDashboardLoadFailed: "טעינת לוח הבקרה נכשלה",
	knowledgeArticlesLoadFailed: "טעינת המאמרים נכשלה",
	knowledgeBase: "מאגר ידע",
	knowledgeCreate: "יצירה",
	knowledgeRunAutoDocs: "הרצת תיעוד אוטומטי",
	knowledgeTotalArticles: "סך המאמרים",
	knowledgePublished: "פורסם",
	knowledgeDrafts: "טיוטות",
	knowledgeAutoGenerated: "נוצר אוטומטית",
	knowledgeLatestUpdatedArticles: "מאמרים שעודכנו לאחרונה",
	knowledgeArticles: "מאמרים",
	knowledgeNewArticle: "מאמר חדש",
	knowledgeFilterArticles: "סינון מאמרים",
	knowledgeCategories: "קטגוריות",
	knowledgeParentCategory: "קטגוריית אב",
	knowledgeIcon: "סמל",
	knowledgeColor: "צבע",
	knowledgeSortOrder: "סדר מיון",
	knowledgeCategorySaved: "הקטגוריה נשמרה",
	knowledgeCategoryDeleted: "הקטגוריה נמחקה",
	knowledgeSearch: "חיפוש",
	knowledgeSearchArticles: "חיפוש מאמרים",
	knowledgePath: "נתיב",
	knowledgeAutoGeneratedDocs: "מסמכים שנוצרו אוטומטית",
	knowledgeSingleRoute: "נתיב יחיד",
	knowledgeNoScreenshots: "ללא צילומי מסך",
	knowledgeGenerateDocumentation: "יצירת תיעוד",
	knowledgeImportGeneratedDocs: "ייבוא מסמכים שנוצרו",
	knowledgeDocumentationGenerationStarted: "יצירת התיעוד התחילה",
	knowledgeImported: "יובא",
	knowledgeGeneratedDocsImported: "יובאו {count} מסמכים שנוצרו",
	knowledgeStarted: "התחיל",
	knowledgeFinished: "הסתיים",
	knowledgeRun: "הרצה",
	knowledgeOutput: "פלט",
	knowledgeStatus_draft: "טיוטה",
	knowledgeStatus_published: "פורסם",
	knowledgeStatus_archived: "בארכיון",
	knowledgeVisibility_public: "ציבורי",
	knowledgeVisibility_private: "פרטי",
	knowledgeVisibility_company: "חברה",
	knowledgeRunStatus_idle: "בהמתנה",
	knowledgeRunStatus_running: "רץ",
	knowledgeRunStatus_completed: "הושלם",
	knowledgeRunStatus_failed: "נכשל",
	meetings: "פגישות",
	meetingsListSubtitle: "חדרים מתוזמנים עם צ'אט APIT ולוח שנה מחוברים.",
	meetingsCreateMeeting: "יצירת פגישה",
	meetingsEditMeeting: "עריכת פגישה",
	meetingsCreateSubtitle: "פגישה = אירוע לוח שנה + קבוצת צ'אט + חדר וידאו.",
	meetingsMeetingType: "סוג פגישה",
	meetingsDate: "תאריך",
	meetingsStartTime: "שעת התחלה",
	meetingsEndTime: "שעת סיום",
	meetingsTimezone: "אזור זמן",
	meetingsVisibility: "נראות",
	meetingsParticipants: "משתתפים",
	meetingsGroupsDepartments: "קבוצות/מחלקות",
	meetingsOptionalGroupIds: "מזהי קבוצות אופציונליים",
	meetingsLocation: "מיקום",
	meetingsReminderTime: "זמן תזכורת",
	meetingsMinutesShort: "דק'",
	meetingsAgenda: "סדר יום",
	meetingsAgendaPlaceholder: "פתיחה\nסקירת עיצוב\nצעדים הבאים",
	meetingsRecordingEnabled: "הקלטה מופעלת",
	meetingsAllowJoinBeforeHost: "אפשר להצטרף לפני המארח",
	meetingsMuteUsersOnEntry: "השתקת משתמשים בכניסה",
	meetingsAllowScreenSharing: "אפשר שיתוף מסך",
	meetingsSaveAsDraft: "שמירה כטיוטה",
	meetingsSaveMeeting: "שמירת פגישה",
	meetingsCreateAndNotifyUsers: "יצירה והודעה למשתמשים",
	meetingsSaved: "הפגישה נשמרה",
	meetingsSaveFailed: "לא ניתן לשמור את הפגישה",
	meetingsJoin: "הצטרפות",
	meetingsOpenChat: "פתיחת צ'אט",
	meetingsParticipantsCount: "{count} משתתפים",
	meetingsType_video: "וידאו",
	meetingsType_audio: "שמע",
	meetingsType_in_person: "פנים אל פנים",
	meetingsType_hybrid: "היברידי",
	meetingsVisibility_private: "פרטי",
	meetingsVisibility_company: "חברה",
	meetingsVisibility_department: "מחלקה",
	meetingsStatus_draft: "טיוטה",
	meetingsStatus_scheduled: "מתוזמן",
	meetingsStatus_live: "חי",
	meetingsStatus_ended: "הסתיים",
	meetingsStatus_cancelled: "בוטל",
	aiSettingsAction: "פעולה",
	aiSettingsAllowedModules: "מודולים מותרים",
	aiSettingsApprove: "אישור",
	aiSettingsApprovalFailed: "אישור נכשל",
	aiSettingsDisabled: "מבוטל",
	aiSettingsEnabled: "מאופשר",
	aiSettingsEvent: "אירוע",
	aiSettingsLogs: "יומנים",
	aiSettingsLoadFailed: "טעינת הגדרות AI נכשלה",
	aiSettingsNoGateway: "שער לא מוגדר",
	aiSettingsNoPendingApprovals: "אין אישורים ממתינים",
	aiSettingsNoLogs: "אין יומנים",
	aiSettingsNoPermission: "הרשאה של מנהל AI חסרה.",
	aiSettingsPendingApprovals: "אישורים ממתינים",
	aiSettingsReject: "דחיית",
	aiSettingsRejectFailed: "דחיית נכשלה",
	aiSettingsRefresh: "רענן",
	aiSettingsRequireApproval: "נדרש אישור",
	aiSettingsStatus: "סטטוס",
	aiSettingsTime: "זמן",
	aiSettingsTitle: "הגדרות AI",
	aiSettingsTool: "כלי",
	aiSettingsUser: "משתמש",
	aiSettingsUpdateFailed: "עדכון הגדרות נכשל",
	aiSettingsDefaultMode: "מצב ברירת מחדל",
	aiSettingsReadOnly: "קריאה בלבד",
	aiSettingsApprovalRequired: "נדרש אישור",
	aiSettingsAdminOnly: "רק מנהל",
	financeActiveCurrencies: "{count} מטבעות פעילים",
	financeAddCurrency: "הוסף מטבע",
	financeCurrencyCode: "קוד",
	financeCurrencyCoefficient: "מקדם",
	financeCurrencyDefault: "ברירת מחדל",
	financeCurrencyName: "שם",
	financeCurrencySymbol: "סמל",
	financeCurrencyUse: "השתמש",
	financeLoadFailed: "טעינת הגדרות הכספים נכשלה",
	financeSaveSettings: "שמור הגדרות",
	financeSavedMessage: "הגדרות הכספים נשמרו",
	financeSaveFailed: "שמירת הגדרות הכספים נכשלה",
	financeSelectedDefault: "ברירת מחדל נבחרת:",
	financeSettingsSubtitle: "מטבעות כאן שולטים בתצוגת הכסף ברירת מחדל בעמודי הכספים וההזמנות.",
	financeSettingsTitle: "הגדרות כספיות",
	hrAccrualCoeffPreview: "תצוגה מקדימה של מקדם",
	hrAccrualCoeffPreviewLine1: "{accrualWorkedHours} שעות עבודה → {accrualVacationHours} שעות חופשה",
	hrAccrualCoeffPreviewLine2: "שעות חופשה שהרווח לשעת עבודה: {hourlyCoefficient}",
	hrAccrualCoeffStoredNote:
		"הצד האחורי מאחסן חישוב זה בדקות כדי שכושר השכר ויתרות חופשה יוכלו להשתמש בערכי ימים חלקיים ללא סטיית עיגול.",
	hrAccrualFixedYearly: "ימי חופשה שנתיים קבועים",
	hrAccrualFixedYearlyDesc:
		"צבור מספר מוגדר של ימי חופשה לאורך השנה תוך שימוש בלוח הזמנים היומי או החודשי הקיים.",
	hrAccrualModelChoice:
		"בחר דגם צבירה פעיל אחד. ימים שנתיים ומקדם שעות עבודה משתמשים בלוגיקה OR, לא משולבים.",
	hrAccrualSuffixMin: "דקות",
	hrAccrualVacationMinutesEarned: "דקות חופשה שהרווח",
	hrAccrualVacationMinutesEarnedDesc: "מספר דקות חופשה שצברו לכל יחידת זמן עבודה.",
	hrAccrualWorkBreak: "הפסקת עבודה",
	hrAccrualWorkBreakDesc: "דקות ללא כיסוי יומי המסווגות כהפסקות בהפסקות ריק משרד.",
	hrAccrualWorkedHoursModel: "שעות עבודה לשעות חופשה",
	hrAccrualWorkedHoursModelDesc:
		"צבור חופשה מזמן עבודה בפועל באמצעות מקדם שעות עבודה הניתן להגדרה.",
	hrAccrualWorkedMinutesUnit: "יחידת דקות עבודה",
	hrAccrualWorkedMinutesUnitDesc: "כמה דקות עבודה צריכות ליצור יחידת צבירה אחת.",
	hrWeekdayFri: "ישישי",
	hrWeekdayMon: "יום ב׳",
	hrWeekdaySat: "שבת",
	hrWeekdaySun: "יום ראשון",
	hrWeekdayThu: "יום חמישי",
	hrWeekdayTue: "יום ג׳",
	hrWeekdayWed: "יום רביעי",
	knowledgeSettingsAiEnabled: "AI מאופשר",
	knowledgeSettingsAiModel: "דגם AI",
	knowledgeSettingsAiProvider: "ספק AI",
	knowledgeSettingsEnableAutoDocs: "הפוך אל תיעוד אוטומטי",
	knowledgeSettingsLanguage: "שפה ברירת מחדל",
	knowledgeSettingsMaxSizeMb: "גודל מאמר מקסימלי MB",
	knowledgeSettingsRootCategory: "קטגוריית שורש לתיעוד אוטומטי",
	knowledgeSettingsSaveSettings: "שמור הגדרות",
	knowledgeSettingsSaved: "הגדרות בסיס ידע עודכנו",
	knowledgeSettingsTitle: "הגדרות",
	knowledgeSettingsUploadExt: "סיומות הורדה מותרות",
	knowledgeSettingsVisibility: "ראות ברירת מחדל",
	nvrAddFromList: "הוסף מצלמות מהרשימה",
	nvrCamerasList: "רשימת מצלמות",
	nvrChannel: "ערוץ",
	nvrChannelId: "ID",
	nvrChannelName: "שם",
	nvrChannelsTitle: "ערוצים הרשומים מה-NVR זה",
	nvrConnectionDesc:
		"הזן IP, יציאה וטמפלט נתיב (רק /.../{channel}... — כמו ב-VLC, ללא חלק rtsp://). הוסף שם משתמש וסיסמה RTSP (רוב ה-NVR זקוקים להם). לחץ שמור כדי להפעיל סריקת רשת אוטומטית, או השתמש בהוספת מצלמות מנתיבים להלן כדי להירשם ערוצים ללא סריקה. פתח מצלמה לצפייה חיה; במפת המשרד, הצב מכשירים כרגיל.",
	nvrConnectionTitle: "NVR — חיבור אחד לכל הערוצים",
	nvrDiscoveryFailed: "הגילוי נכשל",
	nvrEnterPaths: "הזן לפחות ערוץ או נתיב אחד.",
	nvrFoundChannels: "נמצאו {n} ערוץ(ים).",
	nvrFullUrl: "כתובת URL מלאה (ערוץ 101 — אוטומטי מהשדות שלעיל)",
	nvrInitError: "לא ניתן לאתחל NVR. טען מחדש את הדף.",
	nvrIp: "NVR IP",
	nvrIpPasswordRequired:
		"IP NVR וסיסמה שמורה נדרשים. הגדר סיסמה, שמור, ואנו נסרוק ערוצים בשמירה הבאה.",
	nvrLoadFailed: "טעינת NVR נכשלה",
	nvrLiveStatus: "סטטוס חי",
	nvrManualDesc:
		"כאשר סריקה אוטומטית נכשלת (למשל API לא יכול להגיע ל-NVR), רשום ערוצים כאן. השתמש באחד לכל שורה: מספרי ערוץ כמו 101, 201, נתיב כמו /Streaming/Channels/102 או כתובת rtsp:// מלאה. נתיבים משולבים עם טמפלט הנתיב RTSP שלך בעת הזנת מספרים בלבד. שמור NVR קודם אם שינית IP או טמפלט, ואז הוסף שורות וclique הכפתור.",
	nvrManualTitle: "הוסף מצלמות מנתיבי RTSP (ללא סריקת שרת)",
	nvrNotReady: "NVR אינו מוכן. טען מחדש את הדף.",
	nvrNotReadyShort: "NVR אינו מוכן.",
	nvrNotWorking: "לא עובד",
	nvrOfficeMap: "מפת משרד",
	nvrOffline: "אופליין",
	nvrOnline: "מקוון",
	nvrPasswordChangeNote: "שנה וחסוך כדי לעדכן סיסמה שמורה.",
	nvrPasswordLeaveBlank: "השאר ריק כדי לשמור על הסיסמה הנוכחית",
	nvrPasswordRequired: "נדרש לרוב ה-NVR להגילוי ערוצים וזרימה.",
	nvrPasswordStoredLeaveBlank: "סיסמה שמורה; השאר ריק כדי לשמור עליה, או הקלד חדשה.",
	nvrRegisterFailed: "הרישום נתיבים נכשל",
	nvrRegisteredCameras: "{n} מצלמה(ות) רשומה(ות).",
	nvrRtspPassword: "סיסמה RTSP",
	nvrRtspPathTemplate: "טמפלט נתיב RTSP",
	nvrRtspPathTemplateHint: "הקלד רק את הנתיב עם {channel}. אל תזין את מחרוזת rtsp:// המלאה כאן.",
	nvrRtspUsername: "שם משתמש RTSP",
	nvrScanChannels: "סרוק ערוצים שוב",
	nvrScanHint: "זה שומר שדות החיבור הנוכחיים, ואז סרוק.",
	nvrWorkingState: "מצב עבודה",
	nvrWorking: "עובד",
	nvrGridEmpty: "אין ערוצים המקושרים ל-NVR זה עדיין. הפעל גילוי בעמוד NVR.",
	nvrGridLoadFailed: "טעינת ערוצים נכשלה",
	nvrGridLoading: "טוען ערוצים…",
	nvrGridStreamFailed: "התחלה נכשלה",
	nvrGridStreamStopped: "הזרימה הפסיקה",
	nvrGridTitle: "כל ערוצי NVR",
	securityRecordingActiveDays: "ימים פעילים",
	securityRecordingDesc:
		"אפשר הקלטה בצד השרת עבור מצלמות שיש להם הקלטה בשרת מופעלת. לכל מצלמה יכול להיות גם לוח הזמנים שלה למטה.",
	securityRecordingEndTime: "זמן סיום",
	securityRecordingGlobalEnable: "אפשר הקלטה בעולם",
	securityRecordingGlobalEnableDesc:
		"מתג ראשי — השבתת זה עוצרת את כל ההקלטות ללא קשר להגדרות כל מצלמה.",
	securityRecordingLoadFailed: "טעינת הגדרות הביטחון נכשלה",
	securityRecordingLocalFs: "מערכת קבצים מקומית",
	securityRecordingLocalPathNote:
		"הנתיב המקומי מוגדר דרך משתנה הסביבה SECURITY_RECORDING_LOCAL_PATH בשרת.",
	securityRecordingNoScheduleNote: "ללא לוח זמנים — מצלמות יהקליטו 24/7 כאשר הקלטה בשרת מופעלת.",
	securityRecordingRetentionDays: "שמור (ימים)",
	securityRecordingRetentionDesc: "קטעים קדומים מזה יימחקו באופן אוטומטי.",
	securityRecordingS3: "S3 / אחסון אובייקטים תואם",
	securityRecordingS3Note:
		"אישורי S3 מוגדרים דרך משתני סביבה בשרת (AWS_ACCESS_KEY_ID, AWS_SECRET_ACCESS_KEY וכו').",
	securityRecordingSaveSettings: "שמור הגדרות",
	securityRecordingSaved: "הגדרות הביטחון נשמרו.",
	securityRecordingSaveFailed: "שמירת הגדרות נכשלה",
	securityRecordingScheduleDesc:
		"לוח זמנים זה חל על כל מצלמה עם הקלטה בשרת מופעלת שאין להן עקיפה לוח זמנים לכל מצלמה.",
	securityRecordingScheduleEnable: "אפשר לוח זמנים ברירת מחדל (הקלט רק במהלך שעות שנקבעו)",
	securityRecordingScheduleNote:
		"הקלטה תופעל בימים הנבחרים בין שעות אלה. מחוץ לחלון זה, הקלטה מושהית באופן אוטומטי.",
	securityRecordingScheduleTitle: "לוח זמנים הקלטה ברירת מחדל",
	securityRecordingSegmentLength: "אורך קטע (דקות)",
	securityRecordingSegmentLengthDesc: "זה שולט בתדירות שבה וידאו חדש מופיע בכל דף מצלמה.",
	securityRecordingStartTime: "זמן התחלה",
	securityRecordingStorage: "איחסון",
	securityRecordingStorageBackend: "בקצה האחורי לאחסון",
	securityRecordingTitle: "הקלטת מצלמה בשרת",
	securitySurveillanceCameraMedia: "מדיה מצלמה",
	securitySurveillanceDashboard: "לוח ניטור",
	securitySurveillanceNoCameras: "לא נמצאו מצלמות.",
	securitySurveillanceOffline: "אופליין",
	securitySurveillanceOnline: "מקוון",
	teamWorkload: "עומס עבודה של הצוות",
	workloadTasks: "משימות",
	workloadTickets: "כרטיסים",
	workloadSteps: "שלבים",
	assignedEmployee: "עובד משויך",
	boughtDate: "תאריך רכישה",
	broken: "מקולקל",
	depreciation: "פחת",
	deviceStatus: "סטטוס מכשיר",
	handoverDocument: "מסמך מסירה",
	maintenanceSchedule: "לוח זמנים לתחזוקה",
	qrCode: "קוד QR",
	repair: "תיקון",
	repairHistory: "היסטוריית תיקונים",
	replacementDate: "תאריך החלפה",
	retired: "הוצא משימוש",
	returnDocument: "מסמך החזרה",
	warrantyDate: "תאריך אחריות",
	noOpenWorkload: "אין עומס עבודה פתוח",
	attendanceTable: "טבלת נוכחות",
	filteredFrom: "סונן מתוך",
	weekend: "סוף שבוע",
	late: "איחור",
	lateDeparture: "יציאה מאוחרת",
	employees: "עובדים",
	exportToExcel: "ייצוא ל-Excel",
	overtime: "שעות נוספות",
	attendanceNextRefresh: "הרענון הבא",
	refreshAttendanceDevices: "רענון נתונים ממכשירי נוכחות",
	attendanceSyncSuccess: "מכשירי הנוכחות סונכרנו",
	attendanceSyncFailed: "סנכרון מכשירי הנוכחות נכשל",
	// User account security / profile
	contactInformation: "פרטי יצירת קשר",
	accountSecurity: "אבטחת חשבון",
	accountStatus: "סטטוס חשבון",
	accountStatusActive: "פעיל",
	accountStatusLocked: "נעול",
	mustChangePassword: "יש לשנות סיסמה",
	lockedAt: "ננעל ב־",
	passwordLastChanged: "סיסמה שונתה לאחרונה",
	accountSecurityDesc: "סיסמאות נוכחיות לעולם אינן גלויות. השתמשו בסיסמה זמנית או בקישור איפוס מאובטח כאשר יש לשנות פרטי התחברות.",
	accountSecurityHint: "השתמשו ב«איפוס סיסמה» כאשר נדרשת החלפת פרטי התחברות מיידית. השתמשו ב«שליחת קישור איפוס» כאשר המשתמש צריך לבחור סיסמה חדשה בלי שהמנהל יראה סוד כלשהו.",
	lockAccount: "נעילת חשבון",
	unlockAccount: "שחרור נעילת חשבון",
	forcePasswordChangeAction: "כפיית שינוי סיסמה",
	clearForcedPasswordChange: "ביטול כפיית שינוי סיסמה",
	resetPassword: "איפוס סיסמה",
	sendResetLink: "שליחת קישור איפוס",
	sessionVisibilityRequiresPermission: "צפייה בהפעלות ובמכשירים דורשת הרשאה נוספת.",
	resetPasswordConfirmTitle: "לאפס את הסיסמה הזו?",
	resetPasswordConfirmText: "תיווצר סיסמה זמנית והמשתמש יצטרך לשנות אותה בכניסה הבאה.",
	temporaryPasswordGenerated: "נוצרה סיסמה זמנית",
	temporaryPasswordShareHint: "שתפו זאת רק בערוץ מאובטח.",
	sendResetLinkConfirmTitle: "לשלוח קישור לאיפוס סיסמה?",
	sendResetLinkConfirmText: "קישור איפוס מאובטח לשימוש חד־פעמי יישלח למשתמש בדוא״ל.",
	passwordResetLinkSent: "קישור לאיפוס סיסמה נשלח.",
	lockAccountConfirmTitle: "לנעול את החשבון הזה?",
	unlockAccountConfirmTitle: "לשחרר את נעילת החשבון הזה?",
	lockAccountConfirmText: "המשתמש לא יוכל להתחבר עד שחרור הנעילה.",
	unlockAccountConfirmText: "המשתמש יוכל להתחבר שוב מיד.",
	accountLockedMsg: "החשבון ננעל.",
	accountUnlockedMsg: "נעילת החשבון שוחררה.",
	forcePasswordChangeConfirmTitle: "לכפות שינוי סיסמה בכניסה הבאה?",
	removeForcedPasswordChangeConfirmTitle: "לבטל כפיית שינוי סיסמה?",
	forcePasswordChangeConfirmText: "המשתמש יוכל להתחבר רק כדי להשלים שינוי סיסמה לפני השימוש בפלטפורמה.",
	removeForcedPasswordChangeConfirmText: "המשתמש יוכל להמשיך להתחבר כרגיל.",
	forcedPasswordChangeEnabled: "כפיית שינוי סיסמה הופעלה.",
	forcedPasswordChangeRemoved: "כפיית שינוי סיסמה בוטלה.",
	securityUpdated: "האבטחה עודכנה",
	securityActionFailed: "פעולת האבטחה נכשלה",
	knownDevicesAndSessions: "מכשירים ידועים והפעלות פתוחות",
	knownDevicesAndSessionsDesc: "המיקומים משוערים ומייצגים בדרך כלל מקור IP, ספק, יציאת VPN או שער משרדי ולא את המיקום הפיזי המדויק של המכשיר.",
	openSessionsBadge: "{count} פתוחות",
	revokeOtherSessions: "ביטול הפעלות אחרות",
	registeredDevices: "מכשירים רשומים",
	unknownDevice: "מכשיר לא ידוע",
	unknownBrowser: "דפדפן לא ידוע",
	unknownOs: "מערכת הפעלה לא ידועה",
	browserOnOs: "{browser} ב־{os}",
	firstSeen: "נראה לראשונה",
	sessionsBadge: "{count} הפעלות",
	currentDevice: "מכשיר נוכחי",
	noKnownDevices: "עדיין אין מכשירים ידועים רשומים.",
	approximateLoginOrigins: "מקורות התחברות משוערים",
	sessionDetails: "פרטי הפעלה",
	device: "מכשיר",
	network: "רשת",
	lastActive: "פעילות אחרונה",
	approximateLocationUnavailable: "מיקום משוער אינו זמין",
	revoke: "ביטול",
	noAuthSessions: "עדיין אין הפעלות אימות רשומות.",
	sessionOriginApproximateNote: "נתוני מקור ההפעלה משוערים. אין להתייחס למיקום גיאוגרפי של IP כמיקום מדויק של המכשיר.",
	connectedMeansNote: "«מחובר» פירושו שלדפדפן/לאפליקציה עדיין יש שקע חי. «מנותק» פירושו שהדפדפן נסגר או עבר למצב לא מקוון, אך הפעלת ההתחברות השמורה עשויה להישאר תקפה עד התנתקות, ביטול או פקיעה.",
	revokeThisSessionTitle: "לבטל את ההפעלה הזו?",
	revokeThisSessionText: "המכשיר/ההפעלה שנבחרו ייאלצו להתחבר מחדש.",
	revokeSession: "ביטול הפעלה",
	sessionRevoked: "ההפעלה בוטלה",
	sessionRevokedSuccess: "ההפעלה שנבחרה בוטלה בהצלחה.",
	failedToRevokeSession: "ביטול ההפעלה נכשל",
	unableToRevokeSession: "לא ניתן לבטל את ההפעלה שנבחרה.",
	revokeOtherSessionsTitle: "לבטל הפעלות אחרות?",
	revokeOtherSessionsText: "כל ההפעלות של משתמש זה יבוטלו מלבד ההפעלה הנוכחית כאשר המשתמש מבטל את המכשירים שלו.",
	revokeSessions: "ביטול הפעלות",
	sessionsRevoked: "ההפעלות בוטלו",
	revokedSessionsCount: "בוטלו {count} הפעלות.",
	failedToRevokeSessions: "ביטול ההפעלות נכשל",
	unableToRevokeSessions: "לא ניתן לבטל את ההפעלות שנבחרו.",
	failedToLoadSessions: "טעינת ההפעלות נכשלה",
	unableToLoadUserSessions: "לא ניתן לטעון את הפעלות המשתמש.",
	sessionStatusRevoked: "בוטלה",
	sessionStatusConnected: "מחובר",
	sessionStatusDisconnected: "מנותק",
	currentSession: "נוכחית",
	passwordChangeOnly: "שינוי סיסמה בלבד",
	faceId: "Face ID",
	passwordsNeverShownHint: "סיסמאות לעולם אינן מוצגות כאן. השתמשו בלשונית האבטחה כדי לנעול או לשחרר חשבון זה, לכפות שינוי סיסמה, ליצור סיסמה זמנית או לשלוח קישור איפוס.",
	sharedFolders: "תיקיות משותפות",
	flexId: "Flex Id",
	emailNotProvided: "דוא״ל לא סופק",
	anonymousUser: "משתמש אנונימי",
	noMapPointsYet: "עדיין אין נקודות במפה",
	noMapPointsYetDesc: "עדיין אין מיקומי הפעלה עם קואורדינטות משוערות. השרת עדיין יכול לעקוב אחר מכשירים והפעלות ללא ספק גיאוגרפי.",
	googleMapsKeyNotConfigured: "מפתח Google Maps לא הוגדר",
	googleMapsKeyNotConfiguredDesc: "הגדירו REACT_APP_GOOGLE_MAPS_API_KEY כדי להציג את מפת ההפעלות המשוערת.",
	mapFailedToLoad: "טעינת המפה נכשלה",
	mapFailedToLoadDesc: "לא ניתן לטעון את Google Maps כעת.",
	approximateLocation: "מיקום משוער",
	attendanceLastRefreshed: "רענון אחרון",
	quarter: "רבעון",
	year: "שנה",
	currentQuarter: "רבעון נוכחי",
	currentYear: "שנה נוכחית",
	chatClearHistory: "נקה היסטוריה",
	chatClearHistoryConfirm: "לנקות את היסטוריית הצ'אט הזה רק עבורך?",
	chatDeleteForMe: "מחק צ'אט",
	chatDeleteForMeConfirm: "למחוק את הצ'אט הזה רק עבורך? ההיסטוריה הגלויה שלך תימחק והצ'אט ייעלם מהסרגל הצדדי שלך.",
	chatBlockUser: "חסום משתמש",
	chatUnblockUser: "בטל חסימת משתמש",
	chatBlockedSection: "אנשי קשר חסומים",
	chatBlockUserConfirm: "לחסום משתמש זה? הוא לא יוכל לשלוח לך הודעות בצ'אט הזה.",
};
